const translations = {
  login: {
    welcome: 'Benvenuto',
    ssoLogin: 'Effettua l\'accesso tramite l\'email del tuo account',
    customers: 'Clienti',
    sendEmail: 'Invia email',
    otpLogin: 'Accedi tramite email',
    login: 'Login',
    changeEmail: 'Usa un\'altro indirizzo email',
    or: 'OPPURE',
    dontHaveAccount: "Non hai un account?",
    requestAccess: 'Richiedi accesso',
    accessRequestTitle: 'Richiedi accesso',
  },
  domains: {
    customerAdminDeletionConfirm: 'Sei sicuro di voler procedere all\'eliminazione di questo cliente? L\'operazione non può essere annullata',
    customerAdminDeletionSuccess: 'Cliente eliminato con successo',
    luckeyDomainsTitle: 'Domini',
    domainName: 'Nome dominio',
    domainDetails: 'Dettagli dominio',
    domainConfigModifySuccess: 'Configurazioni Dominio modificate e aggiornate',
    domainConfigTitle: 'Configurazioni - Feature Toggling',
    domainConfigDescription: 'JSON di configurazione del dominio. Usalo per abilitare/disablitare funzionalità',
    domainConfigGuide: 'Guida alle Configurazioni',
    domainUsersTitle: 'Managers Dominio',
    domainUsersDescription: 'Impersona uno degli utenti managers per operazioni di manutenzione straordinaria sul dominio.\nCliccando su uno dei managers verrai rediretto a Luckey Web App già autenticato con quell\'account',
    domainUsersWarning: 'ATTENZIONE: Impersonando gli utenti potrai apportare modifiche all\'impianto anche irreversibili, usare la massima cautela',
    noUsersFoundTitle: 'Lista utenti vuota',
    noUsersFoundDescription: 'Non è stato trovato nessun utente in questo dominio',
    noDomainsFoundTitle: 'Nessun dominio trovato',
    noDomainFoundDescription: 'La lista dei domini è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    impersonateSuccess: 'Utente impersonato con successo',
    domainSubsriptionTitle: 'Subscriptions del dominio',
    domainSubsriptionsEmptyTitle: 'Subscriptions non trovate o scadute',
    domainSubsriptionsEmptyDescription: 'Il dominio non ha una subscription attiva. Prova a rinnovarla e ricaricare la pagina',
    domainSubsriptionDescription: 'Lista della subscription del dominio: serrature, utenti e scadenza dominio',
    expiration: 'Scadenza',
    totalNumber: 'Totale',
    used: 'Utilizzati',
    tooMuchElements: 'ATTENZIONE: IL DOMINIO HA SUPERATO IL LIMITE DI ELEMENTI',
    newDomain: 'Nuovo dominio',
    externalReference: 'External reference',
    externalReferenceDetails: 'Ad esempio "data-IdCommessa"',
    productTitle: 'Tipologia Subscription',
    extendDomain: 'Estendi subscriptions dominio',
    extendDomainDescription: 'Estendi il dominio con un add-on o un codice prodotto',
    domainInstallersTitle: 'Installers del dominio',
    domainInstallersDescription: 'Elenco degli utenti Installer presenti nel dominio selezionato',
    domainDeletionTitle: 'Cancellazione dominio',
    domainDeletionDescription: 'Richiedi la cancellazione di questo dominio',
    sendDeletionRequest: 'Invia',
    domainDeletionConfirm: 'Vuoi inviare una richiesta per cancellare questo dominio?',
    domainDeletionSuccess: 'Richiesta inviata con successo',
    customerDeletionTitle: 'Cancellazione cliente',
    customerDeletionConfirm: 'Vuoi inviare una richiesta per cancellare questo cliente?',
    customerDeletionSuccess: 'Richiesta inviata con successo',
    walletDeletionTitle: 'Cancellazione wallet',
    walletDeletionConfirm: 'Vuoi inviare una richiesta per cancellare questo wallet?',
    walletDeletionSuccess: 'Richiesta inviata con successo',
    verifyServiceStatus: 'Stato del servizio',
    impersonateUser: 'Impersona utente',
    impersonate: 'Impersona',
    impersonateReadOnly: 'Impersona in sola lettura',
    domainAdditionalInfo: 'Informazioni dominio',
    domainAdditionalInfoDescription: 'Indica qui delle informazioni aggiuntive sul dominio',
    additionalInfoSavedSuccessfully: 'Note salvate con successo',
    EASY: 'Solo serrature Argo',
    SMART: 'Serrature Argo + Gateway',
    STANDARD: 'Solo serrature V364',
    ENTERPRISE: 'Serrature V364 + Argo',
    numberOfArgoLocks: 'Serrature Argo',
    numberOfVegaLocks: 'Serrature V364',
    numberOfGatewaysLocks: 'Gateways',
    numberOfUsers: 'Utenti',
    numberOfLocks: 'Serrature',
    federatedDomain: 'Dominio collegato a: {{domain}}',
    federatedMasterDomain: 'Dominio Master di un gruppo',
    federatedDomains: 'Gruppo di domini',
    domainFederatedLicense: 'Attenzione: questa subscription è unificata per tutti i domini che fanno capo al dominio principale {{domain}}',
    federatedDomainsDescription: 'Dominio appartiene ad un gruppo',
    installationMode: 'Modalità Installazione',
    domainStandard: 'Dominio legacy',
    domainWithCloudCredits: 'Dominio cloud credits',
    domainIrisRequired: '1RIS Richiesto',
    domainIrisEnabled: '1RIS Abilitato',
    domainIrisEnable: 'Abilita 1RIS',
    domainIrisEnableConfirm: 'Vuoi impostare 1RIS come ABILITATO su questo dominio?',
    editPlantDetails: 'Modifica dettagli impianto',
    editPlantDetailsSuccess: 'Dettagli impianto aggiornati con successo',
    zenDeskId: 'ZenDesk Id',
    lockbaseId: 'Lockbase Id',
    license1ris: 'Licenza 1RIS',
    domainsWithCloudCredits: 'Domini cloud credits',
    domainsLegacy: 'Domini legacy',
    domainSecretsTitle: 'Segreti del dominio',
    domainSecretsDescription: 'Credenziali salvate su questo dominio, mostrate in chiaro',
    domainSecretsEmpty: 'Nessun segreto salvato per questo dominio',
    domainSecretsError: 'Impossibile caricare i segreti del dominio',
    domainSecretsYes: 'Sì',
    domainSecretsNo: 'No',
    domainSecretsCopied: 'Copiato',
    domainSecretsKey: 'Chiave',
    domainSecretsValue: 'Valore',
    domainSecretsAdd: 'Aggiungi chiave',
    domainSecretsEdit: 'Modifica',
    domainSecretsFieldType: 'Tipo campo',
    domainSecretsFieldTypeText: 'Testo',
    domainSecretsFieldTypePassword: 'Password',
    domainSecretsFieldTypeUrl: 'URL',
    domainSecretsFieldTypeBoolean: 'Sì / No',
    domainSecretsShowPassword: 'Mostra valore',
    domainSecretsHidePassword: 'Nascondi valore',
    domainSecretsDelete: 'Elimina campo',
    domainSecretsDeleteConfirm: 'Rimuovere il campo "{{key}}"?',
    domainSecretsSaveError: 'Impossibile salvare i segreti del dominio',
    domainAppConfigurationTitle: 'Verifica login personalizzata',
    domainAppConfigurationDescription: 'Endpoint HTTPS per verificare l\'email utente al login',
    domainAppConfigurationUrlsLabel: 'URL di verifica',
    domainAppConfigurationUrlsHint: 'Un URL HTTPS per riga. Usa {placeholder} per un segmento di path. Lascia vuoto per cancellare la configurazione.',
    domainAppConfigurationFieldsLabel: 'Campi email nella risposta',
    domainAppConfigurationFieldsHint: 'Un nome campo JSON per riga (es. email). Obbligatorio se sono impostati gli URL.',
    domainAppConfigurationLoadError: 'Impossibile caricare la configurazione app',
    domainAppConfigurationSaveError: 'Impossibile salvare la configurazione app',
    domainAppConfigurationInvalidUrl: 'Uno o più URL non sono validi (HTTPS obbligatorio, no IP o localhost)',
    domainAppConfigurationFieldsRequired: 'Almeno un campo email è obbligatorio quando sono configurati gli URL di verifica',
  },
  gateways: {
    deployments: 'Deployments',
    showDeployments: 'Mostra Deployments',
    showLogs: 'Show Logs',
    gatewayLogsTitle: 'Log gateway',
    gatewayLogsTimestamp: 'Ora',
    gatewayLogsLevel: 'Livello',
    gatewayLogsLevelFilter: 'Livello di log',
    gatewayLogsLevelFilterAll: 'Tutti',
    gatewayLogsLevelError: '4 (ERRORE)',
    gatewayLogsLevelInfo: '6 (INFO)',
    gatewayLogsSummary: 'Sintesi',
    gatewayLogsContext: 'Contesto',
    gatewayLogsFullLine: 'Riga completa',
    gatewayLogsMessage: 'Messaggio',
    gatewayLogsEmpty: 'Nessuna riga di log per questo dispositivo nell\'intervallo temporale selezionato.',
    gatewayLogsRefresh: 'Aggiorna',
    gatewayLogsDeviceIdLabel: 'Dispositivo',
    gatewayLogsFilterContext: 'Filtra contesto',
    gatewayLogsFilterContextPlaceholder: 'Contiene…',
    gatewayLogsFilterText: 'Cerca nel log',
    gatewayLogsFilterTextPlaceholder: 'Filtra su riga intera, sintesi…',
    gatewayLogsDateFrom: 'Da',
    gatewayLogsDateTo: 'A',
    gatewayLogsApplyRange: 'Applica intervallo',
    gatewayLogsRangeHint: 'Intervallo massimo tra le date Da e A: 8 giorni di calendario',
    gatewayLogsNoFilterMatch: 'Nessuna riga corrisponde al filtro.',
    gatewayLogsErrorGeneric: 'Impossibile caricare i log dal server. Riprova.',
    getGatewayDeploymentsError: 'Si è verificato un errore nell\'ottenere i Deployments per questo HyperGate. Si prega di riprovare',
    createdBy: 'Creato da',
    noGatewayFoundTitle: 'Nessun HyperGate trovato',
    noGatewayFoundDescription: 'La lista degli HyperGate è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    gatewayName: 'Nome HyperGate',
    luckeyGatewaysTitle: 'HyerGates del sistema',
    lastConnectionDate: 'Ultima connessione: {{ date }}',
    gatewaysDevices: 'Dispositivi',
    gatewaysArtifacts: 'Artifacts',
    gatewaysDeployments: 'Deployments',
    noArtifactFoundTitle: 'Nessun Artifact trovato',
    noArtifactFoundDescription: 'La lista degli Artifacts è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    noDeploymentFoundTitle: 'Nessun Deployment trovato',
    noDeploymentFoundDescription: 'La lista degli Deployment è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    newDeployment: 'Nuovo Deployment',
    deploymentScheduledAt: 'Data di lancio',
    gatewaysArtifact: 'Artifact',
    gateways: 'Gateways',
    artifactName: 'Nome artifact',
    createNewDeployment: 'Lancia deployment',
    selectHyperGates: 'Seleziona HyperGates',
    allGateways: 'Lancia su tutti gli HyperGates',
    HYPERGATE_PRO: 'HyperGate Pro',
    HYPERGATE_ISEO: 'HyperGate Lite',
    deploymentDetail: 'Dettaglio Deployment',
    noDeploymentDetailedFound: 'Nessun Gateway trovato per il deployment',
    noDeploymentDetailedFoundDescription: 'La lista dei gateway per questo deployment è vuota',
    DONE: 'Completato',
    PENDING: 'Rilascio in corso',
    IN_PROGRESS: 'In installazione',
    ERROR: 'Errore',
    deviceId: 'Id dispositivo',
    name: 'Nome',
    gatewayVersion: 'Versione',
    iseoSdkVersion: 'ISEO SDK',
    kernelVersion: 'Kernel Version',
    serialNumber: 'Serial Number',
    noGatewaysFound: 'Nessun Gateway trovato',
    noGatewaysFoundDescription: 'La lista dei gateway è vuota. Prova a modificare i filtri di ricerca e riprova',
    noDeploymentFound: 'Nessun Deployment trovato',
    noArtifactFound: 'No Artifact found',
  },
  credits: {
    pricelistImport: 'Importa listino',
    pricelistImportTitle: 'Importa listino',
    pricelistChooseFile: 'Scegli file (.xlsx, .xls, .csv)',
    pricelistChooseAnotherFile: 'Scegli un altro file',
    pricelistDownloadTemplate: 'Scarica template',
    pricelistSheet: 'Foglio',
    pricelistCompany: 'Azienda',
    pricelistSelectCompany: 'Seleziona l\'azienda di cui importare le righe',
    pricelistError: 'Errore nell\'importazione del listino: {{message}}',
    pricelistStatus_NEW: 'Nuove',
    pricelistStatus_CHANGED: 'Modificate',
    pricelistStatus_READONLY_CHANGED: 'Differenze non modificabili',
    pricelistStatus_UNCHANGED: 'Invariate',
    pricelistStatus_ERROR: 'Errori',
    pricelistStatus_SKIPPED: 'Saltate',
    pricelistFilterAll: 'Tutte',
    pricelistColumnRow: 'Riga',
    pricelistColumnMainTier: 'Main tier',
    pricelistColumnStatus: 'Stato',
    pricelistColumnDetails: 'Dettagli',
    pricelistOnlyInBackend: '{{count}} subscription esistenti non sono nel file e non verranno toccate',
    pricelistParseErrors: 'Righe con errori ({{count}}), verranno saltate',
    pricelistRowError: 'Riga {{row}} ({{sku}}): {{message}}',
    pricelistShowingFirst: 'Mostrate le prime {{count}} righe su {{total}}',
    pricelistNoRows: 'Nessuna riga per questo filtro',
    pricelistApply: 'Applica {{count}} modifiche',
    pricelistApplyTitle: 'Applica listino',
    pricelistApplyConfirm: 'Verranno create {{created}} e aggiornate {{updated}} subscription di questo marketplace. Vuoi continuare?',
    pricelistApplyConfirmWithErrors: 'Verranno create {{created}} e aggiornate {{updated}} subscription di questo marketplace. {{errors}} righe con errori verranno saltate. Vuoi continuare?',
    pricelistApplying: 'Applicazione modifiche: {{done}} / {{total}}',
    pricelistResultSummary: 'Create: {{created}} - Aggiornate: {{updated}} - Fallite: {{failed}}',
    pricelistFailedItem: '{{sku}} (main tier: {{tier}}): {{message}}',
    customerPlantLockbaseId: 'ID Lockbase',
    customerPlantName: 'Nome impianto',
    defaultMarketplace: 'Default',
    setMarketplaceAsDefault: 'Imposta come default',
    marketplaceSetAsDefaultConfirm: 'Vuoi impostare questo marketplace come default?',
    marketplaceSetAsDefaultError: 'Errore nell\'impostazione del marketplace come default',
    notificationStartDate: 'Data di inizio notifica',
    notificationAssociatedServices: 'Servizi associati (opzionale)',
    notificationAssociatedServicesHelp: 'Seleziona uno o più servizi da associare a questa notifica. Lascia vuoto per le notifiche generali del contratto.',
    selectContractServices: 'Seleziona servizi',
    notificationPeriodicMode: 'Modalità pianificazione',
    notificationPeriodicModeStartDate: 'Inizia da una data specifica',
    notificationPeriodicModeDayOfMonth: 'Inizia da un giorno specifico del mese',
    contractServicePrice: 'Prezzo',
    contractServiceOriginalPrice: 'Prezzo originale',
    contractServiceCurrency: 'Valuta',
    notificationRuleFormTitle: 'Regola di Notifica Contratto',
    notificationRuleType: 'Tipo di notifica',
    notificationRuleType_ONCE: 'Una tantum',
    notificationRuleType_PERIODIC: 'Ricorrente',
    notificationSpecificDate: 'Data di notifica',
    notificationIntervalMonths: 'Ripeti ogni',
    notificationDayOfMonth: 'Giorno del mese',
    notificationEmails: 'Indirizzi email',
    notificationEmailsHelp: 'Inserisci gli indirizzi email separati da virgole',
    notificationAssociatedService: 'Servizio associato (opzionale)',
    notificationEnabled: 'Abilitato',
    nextRun: 'Prossima esecuzione',
    schedule: 'Pianificazione',
    notificationIntervalMonths_1: 'Ogni mese',
    notificationIntervalMonths_2: 'Ogni 2 mesi',
    notificationIntervalMonths_3: 'Ogni 3 mesi',
    notificationIntervalMonths_4: 'Ogni 4 mesi',
    notificationIntervalMonths_6: 'Ogni 6 mesi',
    notificationIntervalMonths_12: 'Ogni anno',
    newNotificationRule: 'Nuova notifica',
    editNotificationRule: 'Modifica notifica',
    deleteNotificationRule: 'Elimina notifica',
    deleteNotificationRuleConfirm: 'Vuoi eliminare questa notifica?',
    notificationRuleCreationConfirm: 'Vuoi creare la nuova notifica?',
    notificationRuleEditConfirm: 'Stai per modificare la notifica. Sei sicuro di voler procedere?',
    noNotificationRulesFound: 'Nessuna notifica trovata',
    noNotificationRulesDescription: 'La lista delle notifiche è vuota. Crea una nuova notifica per iniziare.',
    selectContractService: 'Seleziona un servizio',
    noContractServicesFound: 'Nessun servizio trovato per questo contratto',
    noServiceSelected: 'Nessun servizio selezionato (notifica generale)',
    generalContractNotification: 'Notifica generale del contratto',
    serviceSpecificNotification: 'Notifica specifica del servizio',
    andMoreEmails: 'e {{count}} email in più',
    dayOfMonthValidationError: 'Il giorno deve essere compreso tra 1 e 28',
    dayOfMonthHelp: 'Inserisci un giorno compreso tra 1 e 28',
    createCustomerContractNotificationRuleError: 'Errore nella creazione della notifica',
    editCustomerContractNotificationRuleError: 'Errore nella modifica della notifica',
    deleteCustomerContractNotificationRuleError: 'Errore nell\'eliminazione della notifica',
    enterEmail: 'Inserisci indirizzo email',
    domainsPeriodic: 'Domini periodici',
    andMorePlants: 'e {{count}} più',
    andMoreServices: 'e {{count}} più',
    customerContractSearch: 'Cerca contratto',
    domainPeriodic: 'Dominio periodico',
    customerPlantHostname: 'URL dell\'impianto',
    customerPlantSolution: 'Soluzione',
    customerPlantManagement: 'Hosting Type',
    customerPlantModality: 'Modalità',
    customerPlantSubSegment: 'Sotto-segmento',
    customerPlantZendesk: 'ID Zendesk',
    customerPlantLoginData: 'Dati di accesso',
    customerPlantLicense1ris: 'Serial Number Licenza',
    openZendesk: 'Apri Zendesk',
    totalInvoicedWithExplanation: 'Totale fatturato (Prezzo netto x Quantità)',
    netPrice: 'Prezzo netto',
    quantity: 'Quantità',
    totalInvoiced: 'Totale fatturato',
    customerPlantPlatform: 'Platform',
    customerPlantPlatformIris: '1RIS',
    customerPlantPlatformIrisArgo: '1RIS + ARGO',
    customerPlantPlatformArgo: 'ARGO',
    customerPlantSolutionLsa: 'LSA',
    customerPlantSolutionV364: 'V364',
    customerPlantSolutionV364Classic: 'V364 Classic',
    customerPlantSolutionLuckey: 'Luckey',
    customerPlantSolutionArgo: 'Argo',
    customerPlantSolutionFlex: 'Flex',
    customerPlantSolutionLwc: 'LWC',
    customerPlantSolutionAtg: 'ATG',
    customerPlantSolutionVar: 'VAR',
    customerPlantType: 'Tipo di impianto',
    customerPlantTypePreprodPilot: 'Preprod - Pilot',
    customerPlantTypePreprodProduction: 'Preprod - Production',
    customerPlantTypeProdPilot: 'Prod - Pilot',
    customerPlantTypeProdProduction: 'Prod - Production',
    customerPlantTypeProdDisabled: 'Prod - Disabled',
    customerPlantTypeDemo: 'Demo',
    customerPlantTypeDead: 'Dead',
    customerPlantSolutionMechanic: 'Mechanic',
    customerPlantSolutionOther: 'Other',
    customerPlantManagementOnPremiseClassic: 'On Premise::Classic',
    customerPlantManagementOnPremiseVmNative: 'On Premise::VM Native',
    customerPlantManagementOnPremiseVmDockerBased: 'On Premise::VM Docker Based',
    customerPlantManagementOnPremiseContainer: 'On Premise::Container',
    customerPlantManagementOnPremiseOther: 'On Premise::Other',
    customerPlantManagementSaasAzure: 'SaaS::Azure',
    customerPlantManagementSaasAws: 'SaaS:AWS',
    customerPlantManagementOther: 'Other',
    customerPlantModalityPeriodic: 'Periodico',
    customerPlantModalityCredits: 'Crediti',
    createCustomerDomainError: 'Impossibile creare o modificare il dominio. Verifica i dati inseriti e riprova',
    noCustomerDomainFindTitle: 'Nessun impianto trovato',
    noCustomerDomainFindDescription: 'La lista de impianti è vuota. Se hai impostato un filtro di ricerca prova a resettarlo e riprova',
    editCustomerDomain: 'Modifica dominio',
    editCustomerDomainConfirm: 'Stai per modificare i dati dell\'impianto. Sei sicuro di voler procedere?',
    newCustomerDomain: 'Nuovo impianto',
    customerDomainCreationConfirm: 'Vuoi creare il nuovo impianto?',
    deleteCustomerDomainError: 'Impossibile eliminare l\'impianto. Riprova',
    deleteCustomerDomainConfirm: 'Vuoi eliminare l\'impianto?',
    customerContractActivationDate: 'Data di attivazione',
    customerContractDeactivationDate: 'Data di disattivazione',
    customerContractDetails: 'Dettagli contratto',
    contractServices: 'Servizi',
    contractService: 'Servizio',
    contractDocuments: 'Documenti',
    contractNotifications: 'Notifiche',
    deleteCustomerContract: 'Elimina contratto',
    deleteCustomerContractConfirm: 'Vuoi eliminare il contratto?',
    deleteCustomerContractError: 'Impossibile eliminare il contratto. Riprova',
    associateNewPlantToContract: 'Associa nuovo dominio',
    addCustomerPlantMessage: 'Seleziona l\'impianto da aggiungere a questo contratto',
    removeCustomerPlantFromContract: 'Rimuovi',
    removeCustomerPlantFromContractConfirm: 'Vuoi rimuovere l\'impianto dal contratto?',
    addCustomerPlantToContractError: 'Impossibile aggiungere l\'impianto al contratto. Riprova',
    removeCustomerPlantFromContractError: 'Impossibile rimuovere l\'impianto dal contratto. Riprova',
    customerContractStatus_ACTIVE: 'Attivo',
    customerContractStatus_NOT_ACTIVE: 'Inattivo',
    customerContractStatus_CANCELLED: 'Annullato',
    downloadDocument: 'Scarica',
    associateNewDocumentToContract: 'Aggiungi documento',
    addDocument: 'Aggiungi documento',
    addDocumentMessage: 'Seleziona il documento da aggiungere a questo contratto',
    documentName: 'Nome file',
    addDocumentToContractError: 'Impossibile aggiungere il documento al contratto. Riprova',
    deleteContractDocumentConfirm: 'Vuoi eliminare questo documento?',
    deleteContractDocumentError: 'Impossibile eliminare il documento. Riprova',
    noCustomerContractDocumentFindTitle: 'Nessun documento trovato',
    noCustomerContractDocumentFindDescription: 'La lista dei documenti è vuota. Se hai impostato un filtro di ricerca prova a resettarlo e riprova',
    noCustomerContractServiceFindTitle: 'Nessun servizio trovato',
    noCustomerContractServiceFindDescription: 'La lista dei servizi è vuota. Se hai impostato un filtro di ricerca prova a resettarlo e riprova',
    editCustomerContractService: 'Modifica servizio',
    editCustomerContractServiceConfirm: 'Stai per modificare i dati del servizio. Sei sicuro di voler procedere?',
    createCustomerContractServiceError: 'Impossibile creare il servizio. Verifica i dati inseriti e riprova',
    deleteCustomerContractServiceError: 'Impossibile eliminare il servizio. Riprova',
    deleteCustomerContractServiceConfirm: 'Vuoi eliminare il servizio?',
    newCustomerContractService: 'Nuovo servizio',
    customerContractServiceCreationConfirm: 'Vuoi creare il nuovo servizio?',
    customerContractServiceFormTitle: 'Servizio Contratto Cliente',
    duplicateCustomerContractServiceFormTitle: 'Duplica Servizio Contratto Cliente',
    customerDomainFormTitle: 'Impianto',
    manageDomainFromWallet: 'Puoi gestire questo dominio dalla sua pagina wallet: {{walletName}}',
    selectService: 'Seleziona servizio',
    noServicesFound: 'Nessun servizio trovato',
    serviceSubject: 'Oggetto',
    serviceGroupFamily: 'Gruppo famiglia',
    serviceType: 'Tipo',
    searchContractService: 'Cerca servizio per codice, oggetto, gruppo famiglia...',
    contractServiceCode: 'Codice',
    customerServiceSelloutPONumber: 'Numero PO Sell-out',
    customerServiceSfdcId: 'ID SFDC',
    customerContractServiceNotes: 'Note',
    customerContractServiceStatus: 'Stato',
    customerContractServiceStatus_WAITING_FOR_ACTIVATION: 'In attesa di attivazione',
    customerContractServiceStatus_ACTIVE: 'Attivo',
    customerContractServiceStatus_PAUSED: 'In pausa',
    customerContractServiceStatus_CANCELLED: 'Annullato',
    customerContractServiceStatus_INACTIVE: 'Inattivo',
    customerContractServiceStatus_WAITING_TO_BE_DONE: 'In attesa di completamento',
    customerContractServiceStatus_WORK_IN_PROGRESS: 'In lavorazione',
    customerContractServiceStatus_DONE: 'Completato',
    sfdcIdAndSelloutPo: 'ID SFDC | PO Sell-out',
    groupFamilySubjectCode: 'Servizio',
    activationDeactivationStatus: 'Stato',
    noPlantsAssociated: 'Nessun impianto associato',
    noServicesAssociated: 'Nessun servizio associato',
    loadingServices: 'Caricamento servizi...',
    chooseFile: 'Scegli file',
    exportCustomerContractsCSV: 'Esporta CSV',
    exportCustomerContractsXLSX: 'Esporta Excel',
    exportCustomerContractsError: 'Errore nell\'esportazione CSV',
    exportCustomerContractServicesCSV: 'Esporta CSV',
    exportCustomerContractServicesError: 'Errore nell\'esportazione CSV',
    customerAndContract: 'Cliente | Contratto',
    customerContract: 'Contratto',
    customer: 'Cliente',
    customerContractServiceSearch: 'Cerca servizio',
    customerContractName: 'Nome contratto',
    customerContractStatus: 'Stato contratto',
    customerContractSigningDate: 'Data di firma',
    customerContractExpirationDate: 'Data di scadenza',
    marketplaces: 'Marketplaces',
    searchMarketplace: 'Cerca marketplace...',
    marketplaceName: 'Nome marketplace',
    luckeyMarketplaceTitle: 'Marketplaces Luckey',
    noMarketplaceFoundTitle: 'Nessun marketplace trovato',
    noMarketplaceFoundDescription: 'La lista dei marketplace è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    newMarketplace: 'Nuovo marketplace',
    marketplaceCreationConfirm: 'Sei sicuro di voler creare il nuovo marketplace?',
    createMarketplace: 'Crea marketplace',
    marketplaceDetails: 'Dettagli marketplace',
    editMarketplaceCreationConfirm: 'Stai modificando i dati del marketplace, sei sicuro di voler procedere?',
    editMarketplace: 'Modifica marketplace',
    searchCustomer: 'Cerca cliente...',
    customerName: 'Nome cliente',
    luckeyCustomersTitle: 'Clienti',
    noCustomerFindTitle: 'Nessun cliente trovato',
    noCustomerFindDescription: 'La lista dei clienti è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    noCustomerContractFindTitle: 'Nessun contratto di servizio trovato',
    noCustomerContractFindDescription: 'La lista dei contratti di servizio è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    newCustomer: 'Nuovo cliente',
    customerCreationConfirm: 'Sei sicuro di voler creare il nuovo cliente?',
    newUser: 'Nuovo utente',
    userCreationConfirm: 'Sei sicuro di voler creare il nuovo utente?',
    createCustomer: 'Crea cliente',
    customerDetails: 'Dettagli cliente',
    editCreationConfirm: 'Stai modificando l\'anagrafica cliente, sei sicuro di voler procedere?',
    editCustomer: 'Modifica cliente',
    editCreationUserConfirm: 'Stai modificando l\'anagrafica utente, sei sicuro di voler procedere?',
    editCustomerContract: 'Modifica contratto di servizio',
    editCustomerContractConfirm: 'Stai modificando i dati del contratto di servizio, sei sicuro di voler procedere?',
    newCustomerContract: 'Nuovo contratto di servizio',
    customerContractCreationConfirm: 'Sei sicuro di voler creare il nuovo contratto di servizio?',
    editUser: 'Modifica utente',
    customerWallets: 'Wallets di {{customerName}}',
    wallets: 'Wallets',
    contracts: 'Contratti di servizio',
    plants: 'Impianti',
    newWallet: 'Nuovo Wallet',
    walletCreationConfirm: 'Vuoi creare un wallet per il cliente selezionato?',
    createWallet: 'Crea wallet',
    editWallet: 'Modifica wallet',
    walletEditConfirm: 'Vuoi modificare il wallet selezionato?',
    noWalletFoundTitle: 'Nessun wallet trovato',
    noWalletFoundDescription: 'Il cliente non ha nessun wallet associato',
    walletDetails: 'Dettagli Wallet',
    rechargeWallet: 'Ricarica',
    walletRechargeHistory: 'Storico ricariche',
    rechargeRowTitle: 'Crediti modificati',
    rechargeCreditsDescription: 'Il wallet è stato ricaricato di {{credits}} crediti',
    rechargeCardDetails: 'Dettaglio ricarica utilizzata',
    systemParameters: 'Listino',
    systemSubscriptions: 'Subscriptions',
    systemSubscriptionsDescription: 'Queste sono le subscriptions presenti a sistema. Creane di nuove o assegnale ad un dominio esistente',
    newSubscription: 'Nuova Subscription',
    editSubscription: 'Modifica Subscription',
    noSystemSubscriptionFoundTitle: 'Nessuna subscription trovata',
    noSystemSubscriptionFoundDescription: 'Non esiste nessuna subscription a sistema assegnabile ad un dominio',
    products: 'Subscriptions legacy',
    rechargeCards: 'Ricariche',
    noSystemCardFoundTitle: 'Nessuna ricarica trovata',
    noSystemCardFoundDescription: 'Non ci sono ricariche a sistema. Creane di nuove per ricaricare i Wallet dei clienti',
    newCard: 'Nuova ricarica',
    cardStatusUsed: 'Usata',
    cardStatusUnused: 'Non usata',
    cardStatusInactive: 'Disabilitata',
    enableCard: 'Abilita',
    disabledCardTooltip: 'La ricarica sarà abilitata non appena verrà ricevuta la fattura ISEO associata',
    rechargeCardCreditsDetails: 'Questa ricarica vale {{credits}} crediti',
    newTierSubscription: 'Nuova subscription principale',
    pluginAndService: 'Add-on e servizi',
    newPluginSubscription: 'Nuovo add-on o servizio',
    tierSubscription: 'Subscription principale',
    walletSubscriptions: 'Subscriptions',
    noWalletSubscriptionFoundTitle: 'Nessuna subscription trovata',
    noWalletSubscriptionFoundDescription: 'Questo wallet non ha nessuna subscription associata',
    newWalletSubscription: 'Associa nuova subscription',
    editWalletSubscription: 'Modifica subscription',
    newWalletPluginSubscription: 'Associa nuovo add-on o servizio',
    walletConsumption: 'Consumi',
    noWalletUsageFoundTitle: 'Nessun dato trovato',
    noWalletUsageFoundDescription: 'Non sono presenti dati di consumi per questo wallet',
    ACTIVATION: 'Costo attivazione di una subscription o add-on',
    DAILY_USAGE: 'Consumo giornaliero',
    creditConsumptionType: 'Tipologia di consumo',
    consumptionCreditsDescription: 'Il wallet ha consumato {{credits}}',
    consumptionRowTitle: 'Consumo di crediti',
    walletPlants: 'Domini',
    noWalletPlantFoundTitle: 'Nessun dominio trovato',
    noWalletPlantFoundDescription: 'Non è stato trovato alcun dominio per questo wallet',
    newWalletPlant: 'Nuovo dominio',
    deleteWalletSubscription: 'Rimuovi subscription',
    editCard: 'Modifica ricarica',
    rechargeDetails: 'Dettagli ricarica',
    exportWalletsUsageCSV: 'Esporta utilizzo crediti',
    exportWalletsCreditUsageCSV: 'Esporta Wallet Credit',
    PENDING: 'In attivazione',
    ACTIVE: 'Attivo',
    READY_TO_ACTIVATE: 'Pronto per attivazione',
    DISABLED: 'Disabilitato',
    walletStatus: 'Stato del Wallet',
    exportManagersCSV: 'Esporta Managers',
    needCreditsToCreatePlant: 'Per creare un dominio è necessario che il wallet abbia un numero di crediti maggiore di zero',
    customerPlants: 'Impianti',
  },
  sales: {
    hardwareSalesInfo: 'Info vendite',
    domain: 'Dominio',
    hardwareId: 'ID HW',
    hardwareName: 'Nome HW',
    hardwareSerialNumber: 'Seriale HW',
    hardwareModel: 'Modello HW',
    hardwareVendor: 'Linea prodotto HW',
    hardwareType: 'Tipologia HW',
    sfdcId: 'ID SFDC',
    iseoSelloutOrderId: 'ID ord. sell-out ISEO',
    iseoSelloutOrderDate: 'Data ord. sell-out ISEO',
    iseoSelloutInvoiceId: 'ID fatt. sell-out ISEO',
    iseoSelloutInvoiceDate: 'Data fatt. sell-out ISEO',
    sofiaCustRef: 'Cust. Ref. (commessa Sofia)',
    unreconciledHardware: 'Hardware non riconciliato',
    hardwareWithSalesInfo: 'Hardware con info vendita',
    actions: 'Azioni',
    addSalesInfo: 'Aggiungi info vendite',
    editSalesInfo: 'Modifica info vendite',
    iseoSelloutOrder: 'Ordine sell-out ISEO',
    iseoSelloutInvoice: 'Fattura sell-out ISEO',
    selectedSalesInfoError: 'Attenzione! La seleziona non è omogenea. Sei sicuro di voler procedere?',
  },
  errors: {
    errorPreviewingFile: 'Errore nell\'anteprima del file. Verifica il formato file o prova a caricare un file diverso',
    fileFormatNotSupported: 'Formato file non supportato',
    deleteWalletSubscriptionError: 'Si è verificato un errore nel modificare la subscription. Per favore riprova o contatto il nostor team di supporto',
    modifyVarOpportunityError: 'Si è verificato un errore nel modificare la quotazione. Si prega di riprovare',
    error: 'Errore',
    getDomainDetailsError: 'Si è verificato un errore nell\'ottenere i dettagli del dominio. Riprova oppure contatta il Support Sofia',
    updateDomainConfigError: 'Si è verificato un errore nel salvare la configurazione dell\'impianto. Riprova oppure contatta il Support Sofia',
    updatePlantThemeError: 'Si è verificato un errore nel salvare il tema dell\'impianto. Riprova oppure contatta il Support Sofia',
    loginFailed: 'Sessione scaduta, per favore effettua nuovamente il login',
    loginGoogleFailedTitle: 'Google Login Fallito', 
    loginGoogleFailed: 'Assicurati di essere loggato in un account Google dell\'organizzazione Sofia, puoi provare ad aprire questa pagina una sessione di Chrome con il tuo account GSuite Sofia' ,
    loginJagoGoogleFailedTitle: 'Jago Login Fallito',
    loginJagoGoogleFailed: 'Assicurati che su Jago esista una tua utenza collegata al tuo account Google Sofia e riprova',
    impersonateDomainUserError: 'Impossibile impersonare l\'utente selezionato. Verifica che l\'utente sia attivo e riprova o contatta il Support Sofia',
    createDomainError: 'Si è verificato un errore nella creazione del dominio',
    addDomainPluginError: 'Si è verificato un errore nell\'estensione del dominio', 
    addUserDomainError: 'Impossibile creare utente. Controllare se l\'utente è già presente nel dominio o se il dominio ha una subscription valida',
    deleteDomainUserError: 'Impossibile eliminare l\'utente. Per favore riprova',
    errorSaveAdditionalInfo: 'Impossibile aggiornare le note aggiuntive. Per favore riprova o contatta il Support Sofia',
    createCustomerError: 'Impossibile creare il cliente. Controllare se il cliente è già presente e riprovare',
    createUserError: 'Impossibile creare l\'utente. Controllare se l\'utente è già presente e riprovare',
    createVarUserError: 'Impossibile creare l\'utente VAR. Controllare se l\'utente è già presente e riprovare',
    createPlantThemeError: 'Impossibile creare il tema personalizzato. Controllare i dati e riprovare',
    updateVarError: 'Impossibile aggiornare. Controllare i dati e riprovare',
    createCustomerContractError: 'Impossibile creare il contratto di servizio. Controllare i dati e riprovare',
    getCustomerContractDetailsError: 'Impossibile ottenere i dettagli del contratto di servizio selezionato. Per favore riprova',
    getCustomerDetailsError: 'Impossibile ottenere i dettagli del cliente selezionato. Per favore riprova',
    getVarDetailsError: 'Impossibile ottenere i dettagli del VAR selezionato. Per favore riprova',
    getPlantThemeDetailsError: 'Impossibile ottenere i dettagli del tema personalizzato selezionato. Per favore riprova',
    deleteDomainRequestError: 'Impossibile inviare la richiesta. Per favore riprova.',
    deleteWalletRequestError: 'Impossibile inviare la richiesta. Per favore riprova.',
    deleteCustomerRequestError: 'Impossibile inviare la richiesta. Per favore riprova.',
    enableIrisDomainRequestError: 'Impossibile inviare la richiesta. Per favore riprova.',
    updatePlantDetailsError: 'Impossibile aggiornare i dettagli impianto. Per favore riprova',
    createCustomerWalletError: 'Impossibile creare il wallet. Per favore riprova',
    editCustomerWalletError: 'Impossibile modificare il wallet. Per favore riprova',
    getWalletDetailsError: 'Impossibile ottenere i dettagli del wallet selezionato. Per favore riprova',
    openSystemParametersError: 'Impossibile aprire i parametri di sistema. Per favore riprova',
    createSubscriptionError: 'Impossibile creare la subscription. Per favore riprova',
    createCardError: 'Si è verificato un errore nel creare la ricarica. Per favore riprova',
    createVarOpportunityError: 'Si è verificato un errore durante la creazione. Per favore riprova',
    editVarOpportunityError: 'Si è verificato un errore durante la modifica. Per favore riprova',
    rechargeWalletError: 'Si è verificato un errore nella ricarica del Wallet. Per favore riprova',
    deleteCardError: 'Si è verificato un errore nel cancellare la ricarica. Verifica che non sia in uso e riprova',
    enableCardError: 'Si è verificato un errore nell\'aggiornamento della ricarica. Verifica che non sia in uso e riprova',
    deletePlantThemeError: 'Si è verificato un errore durante la cancellazione. Verifica che non sia in uso e riprova',
    deleteVarUserError: 'Si è verificato un errore durante la cancellazione. Verifica che non sia in uso e riprova',
    deleteVarUserErrorOpportunities: 'Questo utente è proprietario di almeno una quotazione, quindi non può essere eliminato. Riassegna le quotazioni di questo utente e riprova',
    deleteVarOpportunityError: 'Si è verificato un errore durante la cancellazione. Verifica che non sia in uso e riprova',
    rejectVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    approveVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    syncsfdcidVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    upgradeVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    winVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    loseVarOpportunityError: 'Si è verificato un errore durante l\'aggiornamento della quotazione. Verifica che non sia in uso e riprova',
    deleteUserError: 'Si è verificato un errore durante la cancellazione. Verifica che non sia in uso e riprova',
    createWalletSubscriptionError: 'Si è verificato un errore nell\'associazione della subscription al wallet. Per favore riprova',
    createWalletPlantError: 'Si è verificato un errore nel creare il dominio. Per favore riprova',
    walletActionErrorNotEnoughCreditsTitle: 'Crediti insufficienti',
    walletActionErrorNotEnoughCredits: 'Il wallet non ha abbastanza crediti per effettuare l\'operazione. Verifica l\'operazione o ricarica il wallet e riprova',
    warningMinCreditsCard: 'Attenzione! Minimo numero di crediti richiesto = {{credits}}',
    loginJagoOTPEmailFailedTitle: 'Errore invio email',
    loginJagoOTPEmailFailed: 'Si è verificato un errore nell\'invio della mail, riprovare tra 5 minuti',
    loginJagoOTPFailedTitle: 'Errore verifica codice',
    loginJagoOTPFailed: 'La verifica del codice di accesso non è andata a buon fine. Controllare il codice immesso oppure aspettare 5 minuti e riprovare l\'accesso',
    getGatewayDetailsError: 'Si è verificato un errore nell\'ottenere i dettagli dell\'HyperGate. Riprova oppure contatta il Support Sofia',
    createDeploymentError: 'Si è verificato un errore nel creare il deployment. Per favore riprova',
    addonV364missing: 'Non è stato possibile trovare l\'add-on relativo a V364 nel sistema, contattare l\'assistenza.',
    openIseoTrainingMaterialsError: 'Si è verificato un errore nel caricamento dei materiali formativi ISEO. Per favore riprova',
  },
  forms: {
    createResource: 'Crea risorsa',
    subscriptionCategory: 'Categoria',
    createNew: 'Nuovo',
    aggregateByMonth: 'Aggrega per mese',
    findOutMore: 'Scopri di più',
    findOutMoreAboutThisFeature: 'Scopri di più su questa funzionalità',
    extraCredentials: 'Credenziali extra',
    invitations: 'Inviti attivi',
    anonymizeAllEvents: 'Elimina dati utente dagli eventi serratrure e di gestione',
    deleteAllStandardDevices: 'Elimina tutte le tessere RFID, PIN e F9000 assegnate a questo utente',
    numberOfDomains: 'Domini',
    walletDetails: 'Dettagli wallet',
    subscriptionDetails: 'Dettagli subscription',
    smartLocks: 'Serrature',
    users: 'Utenti',
    numberOfElements: 'Elementi',
    segment: 'Segmento',
    otpLoginOnly: 'Abilita login esclusivo tramite OTP per questo impianto',
    varEditSuccess: 'VAR aggiornato con successo',
    invalidEmail: 'Email non valida',
    synchronizationCompleted: 'Sincronizzazione completata con successo',
    sfdcSync: 'SFDC Sync',
    customerVatVerificationTitle: 'Sincronizza i dati del cliente dai sistemi ISEO',
    customerAdditionalData: 'Dati aggiuntivi',
    verify: 'Verifica',
    visible: 'Visibile sul sito',
    notVisible: 'Non visibile sul sito',
    exportAllUsers: 'Esporta utenti',
    montlyBurnRate: '{{credits}}/mese',
    nextRechargeForecast: 'Prossima ricarica prevista con i consumi attuali ~{{date}}',
    creditsFinishedInDate: "Crediti terminati il {{date}}",
    lastUpdate: 'Ultimo aggiornamento {{time}}',
    rowsPerPage: 'Elementi per pagina',
    permissionsDetails: 'Dettaglio permessi',
    rolePermissions: 'Permessi',
    clusterAndIseoCompany: 'Cluster e consociata ISEO',
    createCardSuccess: 'Ricarica creata con successo',
    cardDetails: 'Dettaglio ricarica',
    status: 'Stato',
    customerInfo: 'Dettagli cliente',
    details: 'Dettagli',
    costs: 'Costi',
    hostName: 'Hostname',
    domainType: 'Tipologia',
    user: 'Utente',
    logoutConfirmation: 'Sei sicuro di voler effettuare il logout?',
    send: 'Invia',
    askQuestion: 'Scrivici',
    ticketOpenSuccessfully: 'La tua domanda è stata inviata al nostro team! Uno dei nostri membri ti contatterà a breve.',
    ticketOpenError: 'Si è verificato un errore durante l\'invio della richiesta. Per favore riprova',
    writeUsAQuestionDescription: 'Hai una domanda? Scrivici la tua richiesta e uno dei nostri Product Specialist sarà pronto ad assisterti',
    deviceType: 'Tipo dispositivo',
    createNewMarketplace: 'Nuovo marketplace',
    createNewCustomer: 'Crea',
    firstName: 'Nome',
    lastName: 'Cognome',
    email: 'Email',
    contactEmail: 'Email di contatto',
    marketplace: 'Marketplace',
    export: 'Esporta',
    open: 'Apri',
    add: 'Aggiungi',
    actions: 'Azioni',
    search: 'Cerca',
    remove: 'Rimuovi',
    delete: 'Elimina',
    duplicate: 'Duplica',
    deleteRequest: 'Richiedi eliminazione',
    deleteAdminOnly: 'Elimina (admin)',
    copy: 'Copia',
    expiresAt: 'Scadenza: {{expirationDate}}',
    error: 'Errore',
    activateLicense: 'Attiva subscription',
    loadingUserList: 'Carico gli utenti...',
    cancel: 'Annulla',
    confirm: 'Conferma',
    warning: 'Attenzione',
    close: 'Chiudi',
    reset: 'Reset',
    save: 'Salva',
    spinnerLoading: 'Caricamento...',
    detailsGeneric: 'Dettagli',
    createNewDomain: 'Crea nuovo dominio',
    walletName: 'Nome wallet',
    domainName: 'Nome dominio',
    domainNamePreview: 'Anteprima',
    domainFormTitle: 'Crea un nuovo dominio Luckey',
    invalidDomainName: 'Etichetta dominio non valida. Massimo 50 caratteri: lettere e numeri, trattino solo in mezzo (non all\'inizio o alla fine), niente spazi',
    selectProduct: 'Seleziona una tipologia',
    name: 'Nome',
    lastname: 'Cognome',
    createNewUser: 'Crea nuovo Manager',
    selectRole: 'Seleziona ruolo utente',
    createUserForDomain: 'Crea un nuovo utente Manager per il dominio selezionato',
    newUser: 'Nuovo utente',
    password: 'Password',
    letUserChoosePassword: 'Fai scegliere password all\'utente: manda link di impostazione password all\'email indicata',
    domainCreateSuccess: 'Dominio creato con successo',
    domainCreateUserAfterCreation: 'Vuoi creare un utente per il nuovo dominio?',
    domainCreationConfirm: 'Si vuole procedere a creare il nuovo dominio?',
    createDomain: 'Crea dominio',
    username: 'Username',
    domainExtendsConfirm: 'Si vuole procedere ad estendere il dominio col prodotto selezionato?',
    createNewInstaller: 'Crea nuovo Installer',
    newInstaller: 'Nuovo Installer',
    createInstallerForDomain: 'Crea un nuovo utente installatore per il dominio selezionato',
    deleteDomain: 'Richiedi cancellazione dominio',
    active: 'Attivo',
    disabled: 'Disattivato',
    impersonateUserDescription: 'Prima di impersonare l\'utente all\'interno dell\'impianto ti avvisiamo che:',
    impersonateUserDescriptionOne: 'L\'inizio della sessione e la sua durata appariranno nei logs dell\'impianto',
    impersonateUserDescriptionTwo: 'Ogni tua azione sarà registrata e apparirà nei logs dell\'impianto',
    impersonateUserDescriptionThree: 'Qualsiasi azione che effettuerai sull\'impianto avrà affetto in maniera istantanea e in alcuni casi irreversibile',
    selectSessionDuration: 'Seleziona durata della sessione di supporto',
    impersonateReadOnly: 'Modalità sola lettura',
    impersonateReadOnlyDescription: 'Accedi all\'impianto in modalità sola lettura, potrai visualizzare i dati dell\'impianto ma senza poterli modificare',
    impersonateReadOnlyWarning: 'Attenzione: La sessione di supporto e la sua durata saranno comunque visibile nei logs dell\'impianto',
    minutes: '{{minutes}} minuti',
    selectSessionDurationPlaceholder: 'Durata sessione',
    installationModeActive: 'Attiva',
    installationModeDisabled: 'Disattivata',
    customerFormTitle: 'Cliente Luckey',
    customerContractFormTitle: 'Contratto di servizio',
    varFormTitle: 'Value Added Reseller (VAR)',
    varFormAdminSection: 'Sezione admin',
    varFormTitleVar: 'Informazioni aziendali',
    plantThemeFormTitle: 'Tema Luckey personalizzato',
    customerName: 'Nome cliente',
    invalidCustomerName: 'Nome cliente non valido',
    marketplaceFormTitle: 'Marketplace Luckey',
    marketplaceName: 'Nome marketplace',
    invalidMarketplaceName: 'Nome marketplace non valido',
    createNewWallet: 'Nuovo Wallet',
    whatsNewTitle: 'Luckey what\'s new!',
    whatsNewSubtitle: 'Scopri le ultime novità su Luckey e Sofia part of ISEO',
    required: 'Obbligatorio',
    notes: 'Note aggiuntive',
    cardCode: 'Codice ricarica',
    recharge: 'Ricarica',
    rechargeWalletFormDescription: 'Ricarica i crediti di questo wallet inserendo il codice di ricarica. La ricarica avrà effetto immediatamente',
    subscriptionName: 'Nome subscription',
    subscriptionFixedPrice: 'Crediti consumati al momento dell\'attivazione',
    subscriptionBurnRate: 'Consumo crediti giornaliero',
    subscriptionVisible: 'Visibile nel marketplace',
    createNewSubscriptionDescription: 'Crea una nuova subscription nel sistema. La nuova subscription sarà disponibile a tutti i domini',
    subscriptionBurnRateDescription: 'Indica quanti Cloud Credits consumerà al giorno questa subscription una volta attivata',
    subscriptionFixedPriceDescription: 'Indica quanti Cloud Credits consumerà questa subscription al momento dell\'attivazione',
    subscriptionLogic: 'Logica di conteggio',
    selectLogic: 'Seleziona logica',
    subscriptionLogicDescription: 'Indica quali elementi del sistema verranno conteggiati per determinare i vincoli del sistema',
    FIXED: 'Non mettere vincoli di elementi',
    COUNT_USERS_LOCKS: 'Limita separatamente il numero di utenti e le serrature del dominio',
    COUNT_LOCKS: 'Limita solo il numero serrature del dominio',
    COUNT_ELEMENTS: 'Limita la somma serrature e utenti del dominio',
    maxLocks: 'Massimo numero di serrature',
    maxUsers: 'Massimo numero di utenti',
    maxElements: 'Massimo numero di elementi (utenti + serrature)',
    subscriptionMaxLocksDescription: 'Indica il massimo numero di serrature installabili con questa subscription',
    subscriptionMaxUsersDescription: 'Indica il massimo numero di utenti attivabili con questa subscription',
    subscriptionMaxElementsDescription: 'Indica il massimo numero di elementi con questa subscription',
    subscriptionResource: 'Risorsa',
    cardQuantity: 'Numero di crediti',
    cardQuantityDescription: 'Indica il numero di crediti che saranno ricaricati al momento dell\'utilizzo della ricarica',
    cardVar: 'Assegna ricarica ad un VAR',
    cardWallet: 'Assegna ricarica ad un wallet specifico',
    cardNotes: 'Note aggiuntive',
    createCardConfirm: 'Sei sicuro di voler creare la ricarica?',
    createVarOpportunityConfirm: 'Sei sicuro di voler creare la nuova quotazione?',
    createSubscrptionConfirm: 'Sei sicuro di voler creare la nuova subscription?',
    rechargeWalletConfirm: 'Sei sicuro di voler ricaricare il wallet di questo cliente? L\'operazione non può essere annullata',
    createdAt: 'Data creazione',
    copiedSuccess: 'Copiato!',
    logout: 'Esci',
    deleteCardConfirm: 'Sei sicuro di voler eliminare questa ricarica? L\'operazione non può essere annullata',
    enableCardConfirm: 'Sei sicuro di voler abilitare all\'attivazione questa ricarica? Una volta abilitata, questa ricarica potrà essere usata. L\'operazione non può essere annullata',
    newTierSubscription: 'Nuova subscription principale',
    pluginAndService: 'Add-on e servizi',
    newPluginServiceSubscription: 'Nuovo add-on o servizio',
    subscriptionTierSelectionTitle: 'Subscription principale',
    subscriptionTierSelectionDescription: 'Selezionando la subscription principale il nuovo add-on erediterà automaticamente le logiche di conteggio della subscription principale',
    selectTier: 'Seleziona subscription',
    createPluginSubscriptionConfirm: 'Sei sicuro di voler procedere alla creazione del nuovo add-on/servizio?',
    createWalletSubscriptionConfirm: 'Sei sicuro di voler associare la subscription al wallet selezionato? La subscription sarà attivata anche in tutti gli impianti gestiti tramite questo wallet',
    deleteWalletSubscriptionConfirm: 'Sei sicuro di voler rimuovere la subscription dal wallet selezionato? La subscription sarà rimossa anche da tutti gli impianti gestiti tramite questo wallet',
    editSubscriptionConfirm: 'Sei sicuro di voler modificare la subscription?',
    walletSelectSubscriptionTitle: 'Subscription da attivare',
    walletSelectSubscriptionDescription: 'Seleziona la subscription da attivare su questo wallet. Ricorda che la licensa sarà attivata anche in tutti gli impianti gestiti tramite questo wallet',
    createWalletPlantConfirm: 'Sei sicuro di voler creare il nuovo dominio per il wallet selezionato?',
    enableEmailForPlant: 'Abilita servizio email',
    enableEmailForPlantDescription: 'Abilitia l\'invio di email per questo impianto (email di attivazione, notifice, etc.)',
    enableIrisRequiredForPlant: 'Richiedi Servizio 1ris',
    enableIrisRequiredForPlantDescription: 'Se selezionato, il dominio sarà preparato per includere il Servizio 1ris',
    cardSubscriptionsLinked: 'Subscriptions associate',
    cardSubscriptionsLinkedDescription: 'Associa uno o più add-on o servizi a questa ricarica, saranno attivati una volta che la ricarica verrà effettuata',
    cardMarketplacesLinked: 'Marketplace associazione subscription',
    cardMarketplacesLinkedDescription: 'Seleziona un marketplace per selezionare le subscriptions da associare a questa ricarica',
    mainTierDescription: 'Associa una subscription principale a questa ricarica, sarà attivata una volta che la ricarica verrà effettuata',
    sku: 'SKU',
    customerData: 'Anagrafica cliente',
    customerVat: 'P.IVA',
    customerFiscalCode: 'Codice fiscale',
    customerCountry: 'Stato',
    customerAddress: 'Indirizzo',
    customerCity: 'Città',
    customerEmail: 'Email',
    customerPhone: 'Telefono',
    customerCrmId: 'SFDC ACCOUNT ID',
    customerMarketplace: 'Marketplace',
    customerCertifiedEmail: 'PEC',
    customerCluster: 'Cluster',
    customerVar: 'VAR',
    customerCompany: 'Consociata ISEO',
    customerPostalCode: 'CAP',
    customerPrincipalSubDivision: 'Provincia, Stato, Contea, ecc.',
    iseoSalesOrderReference: 'Ordine di vendita ISEO (ISEO -> Cliente)',
    iseoSalesOrderDate: 'Data ordine di vendita ISEO',
    iseoPurchaseOrderReference: 'Ordine di acquisto ISEO (ISEO -> Sofia)',
    iseoPurchaseOrderDate: 'Data ordine di acquisto ISEO',
    sofiaSalesOrderReference: 'Ordine di vendita Sofia (Sofia -> ISEO)',
    sofiaSalesOrderDate: 'Data conferma ordine di vendita Sofia',
    pickDate: 'Scegli data',
    crmSource: 'CRM sorgente opportunità',
    crmId: 'Identificativo univoco opportunità CRM',
    sofiaProjectId: 'Identificativo riferimento progetto Sofia',
    crmLink: 'Link a opportunità in CRM',
    kamReference: 'KAM di riferimento',
    edit: 'Modifica',
    editCardConfirm: 'Sei sicuro di voler modificare la ricarica?',
    editVarOpportunityConfirm: 'Sei sicuro di voler modificare questa quotazione?',
    insertEmailOTPLoginForm: 'Inserisci l\'email del tuo account per ricevere il codice OTP ed effettuare l\'accesso',
    insertEmailOTPLoginFormDisclaimer: 'Se l\'email è autorizzata riceverai il codice OTP per effettuare l\'accesso',
    insertOTPOTPLoginForm: 'Inserisci il codice OTP che hai ricevuto sulla tua email',
    insertOTPOTPLoginFormDisclaimer: 'Nel caso in cui non si riceva il codice dopo 5 minuti ripetere l\'operazione',
    otp: 'OTP',
    pickDateTo: 'Scegli data fine:',
    pickDateFrom: 'Scegli data inizio:',
    provisioningType: 'Tipologia di attivazione',
    AUTOMATIC: 'Attivazione automatica',
    MANUAL: 'Attivazione manuale',
    SEMI_AUTOMATIC: 'Attivazione semi-automatica',
    AUTOMATIC_Description: 'L\'estensione può essere attivata in autonomia dallo store. I crediti di attivazione verranno scalati immediatamente',
    MANUAL_Description: 'Estensione attivabile solo a valle di richiesta esplicita del cliente. I crediti saranno scalati manualmente a valle dell\'approvazione della richiesta',
    SEMI_AUTOMATIC_Description: 'Estensione attivabile solo a valle di richiesta esplicita del cliente. I crediti di attivazione saranno scalati al momento della richiesta',
    requestToQuote: 'Quotazione richiesta',
    requestToQuoteDescription: 'Indica se l\'estensione è soggetta a quotazione al posto dell\'utilizzo diretto dei crediti (es. integrazioni e customizzazioni)',
    subscriptionCanBeDeactivated: 'Disabilitabile da manager',
    subscriptionCanBeDeactivatedDescription: 'Indica se il manager può disabilitare la subscription dal Luckey Store',
    selectSegmentType: 'Seleziona segmento',
    sofiaInvoiceNumber: 'Numero fattura sofia',
    sofiaInvoiceAmount: 'Ammontare importo crediti in fattura sofia',
    sofiaInvoiceYear: 'Anno fattura sofia',
    iseoInvoiceNumber: 'Numero fattura ISEO',
    iseoInvoiceAmount: 'Ammontare fattura ISEO',
    iseoInvoiceYear: 'Anno fattura ISEO',
    freeOfCharge: 'Gratuita',
    freeOfChargeReason: 'Motivazione',
    currency: 'Valuta',
    sofiaInvoiceDate: 'Data fattura',
    iseoInvoiceDate: 'Data fattura',
    sofiaInvoiceRecipient: 'Destinatario fattura',
    iseoInvoiceRecipient: 'Destinatario fattura',
    serviceSupplementaryInvoice: 'Complemento di Servizio',
    serviceSupplementaryInvoiceNumber: 'Numero fattura',
    serviceSupplementaryInvoiceAmount: 'Ammontare fattura',
    serviceSupplementaryInvoiceDate: 'Data fattura',
    serviceSupplementaryInvoiceRecipient: 'Destinatario fattura',
    iseoInvoiceIssuer: 'Emittente fattura',
    backdropClosing: 'Sei sicuro di voler chiudere il form senza salvare?',
    roles: 'Ruoli',
    selectBotType: 'Seleziona tipo assistente',
    helperBot: 'Assistente Tecnico',
    commercialBot: 'Assistente Commerciale',
    talkWithUs: 'Assistente AI',
    noBotTypeSelected: 'Nessun assistente selezionato',
    customer: 'End-user standard',
    simplifiedCustomer: 'End-user semplificato',
  },
  activations: {
    cluster: 'Cluster',
    clusters: 'Clusters',
    getInfo: '(Visualizza la guida)',
    createNewCustomer: 'Crea customer',
    createNewWallet: 'Crea wallet',
    createNewScratchcard: 'Crea scratchcard',
    yearsString: 'anni',
    monthsString: 'mesi',
    daysString: 'giorni',
    addNewActivationButton: 'Aggiungi richiesta attivazione',
    home: 'OD Home',
    activationRequests: 'Richieste attivazione',
    rechargeRequests: 'Richieste ricarica',
    walletStatus: 'Stato ordini',
    noActivationsFoundTitle: 'Nessuna richiesta trovata',
    noActivationsFoundDescription: 'Non ci sono richieste nel sistema. Creane di nuove per iniziare.',
    selloutOrder: 'Ordine Sell-out',
    intragroupOrder: 'Ordine Intra-group',
    custref: 'Cust. Ref.',
    rejectedReason: 'Motivo di rifiuto',
    changeStatusToUnderReview: 'Manda in revisione',
    changeStatusToInvoiced: 'Contrassegna fatturata',
    changeStatusToCreated: 'Contrassegna creata',
    changeStatusToRejected: 'Rifiuta richiesta',
    changeStatusToProcessing: 'Accetta richiesta',
    changeStatusAdmin: 'Imposta stato (admin)',
    changeCustRef: 'Imposta Cust. Ref.',
    search: 'Cerca...',
    resetFilters: 'Resetta filtri',
    statusSelection: 'Qualsiasi stato',
    clusterSelection: 'Qualsiasi cluster',
    statusDRAFT: 'Bozza',
    statusUNDER_REVIEW: 'In revisione',
    statusREJECTED: 'Rifiutata',
    statusPROCESSING: 'In elaborazione',
    statusCREATED: 'Creata',
    statusINVOICED: 'Fatturata',
    statusACTIVE: 'Attiva',
    statusDELETED: 'Eliminata',
    saveDraft: 'Salva come bozza',
    customMarketplaceWarning: 'Il cliente non è associato al marketplace predefinito. Dovrai specificare manualmente la baseline subscription ed eventuali addons nella sezione \'Note\'',
    subscriptionNotFoundError: 'Subscription non trovata',
    deleteActivationConfirm: 'Sei sicuro di voler eliminare questa richiesta? L\'operazione non può essere annullata',
    deleteActivationError: 'Si è verificato un errore nella cancellazione della richiesta. Per favore riprova',
    promoteActivationConfirm: 'Sei sicuro di voler mandare la richiesta in revisione? Non sarà più possibile modificare la richiesta',
    promoteActivationError: 'Si è verificato un errore nella promozione della richiesta. Per favore riprova',
    createdActivationConfirm: 'Sei sicuro di voler mandare la richiesta in stato CREATA?',
    createdActivationError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    invoicedActivationConfirm: 'Sei sicuro di voler segnare la richiesta come fatturata?',
    invoicedActivationError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    editStatusActivationConfirm: 'Sei sicuro di voler modificare lo stato di questa richiesta? L\'operazione non può essere annullata',
    editStatusActivationError: 'Si è verificato un errore nella modifica stato della richiesta. Per favore riprova',
    rejectActivationConfirm: 'Specifica le motivazioni per il rifiuto di questa richiesta.',
    rejectActivationError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    processingActivationConfirm: 'Sei sicuro di voler accettare la richiesta?',
    processingActivationError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    newFileName: 'Specifica il nome del file',
    newFileExtensionError: 'Il file selezionato ha un\'estensione non supportata',
    newFileDuplicateNameError: 'Questo nome è già stato usato per un altro file. Cambia il nome e ripeti l\'operazione.',
    editCustrefConfirm: 'Specifica il Cust. Ref. di questa richiesta.',
    editCustrefError: 'Si è verificato un errore nell\'aggiornamento del Cust. Ref., per favore riprova',
    editActivation: 'Modifica richiesta',
    newActivation: 'Aggiungi richiesta',
    viewActivation: 'Visualizza richiesta',
    newActivationError: 'Si è verificato un errore nella creazione della richiesta. Per favore riprova',
    editActivationError: 'Si è verificato un errore nel salvataggio della richiesta. Per favore riprova',
    noSubscriptionFoundDescription: 'La lista di subscription è vuota. Se hai impostato dei filtri di ricerca prova a resettarli',
    customerSearch: 'Cerca tra i clienti esistenti',
    customerSearchEnterName: 'Cerca per nome...',
    customerSearchNoMatch: 'Nessun cliente trovato...',
    customerProceedWithSelected: 'Usa cliente selezionato',
    customerProceedWithNew: 'Crea nuovo cliente',
    customerConfirmData: 'Conferma dati cliente',
    customerData: 'Anagrafica cliente',
    varSearch: 'Cerca tra i VAR esistenti',
    varSearchEnterName: 'Cerca per nome...',
    varSearchNoMatch: 'Nessun VAR trovato...',
    varProceedWithSelected: 'Usa VAR selezionato',
    varData: 'Anagrafica VAR',
    selectCustomerOrVar: 'Seleziona il destinatario della richiesta (cliente o VAR)',
    varSfdcId: 'SFDC ACCOUNT ID',
    varName: 'Nome',
    customerFormTitle: 'Cliente Luckey',
    customerName: 'Nome cliente',
    customerVat: 'P.IVA',
    customerFiscalCode: 'Codice fiscale',
    customerCountry: 'Stato',
    customerAddress: 'Indirizzo',
    customerCity: 'Città',
    customerEmail: 'Email',
    customerPhone: 'Telefono',
    customerCrmId: 'SFDC ACCOUNT ID',
    customerMarketplace: 'Marketplace',
    customerCertifiedEmail: 'PEC',
    customerCluster: 'Cluster',
    customerCompany: 'Consociata ISEO',
    customerPostalCode: 'CAP',
    customerPrincipalSubDivision: 'Provincia, Stato, Contea, ecc.',
    exportActivationsCSV: 'Esporta CSV',
    salesAndOrdersData: 'Vendita e ordini',
    basicData: 'Informazioni impianto',
    formEnterAnswer: 'La tua risposta',
    formEnterAnswerGT0: 'Numero maggiore di zero',
    formEnterAnswerFrom0To600: 'Numero compreso tra 0 e 600',
    formEnterAnswerOwnerEmail: 'Email owner',
    formEnterAnswerKamEmail: 'Email Key Account Manager',
    formEnterAnswerPmEmail: 'Email PM',
    formEnterAnswerSystemEngineerEmail: 'Email System Engineer',
    optId: 'ID opportunità (SFDC)',
    salesOrderConfirmationNumber: 'Sales Order Confirmation Number (sell-out)',
    salesOrderConfirmationNumber_desc: '',
    selloutFiles: 'Sell-out order PDF (hardware + software + professional services)',
    selloutFiles_desc: 'Necessario per tracciare correttamente le revenues Blossom.',
    selloutFiles_desc2: 'Limite numero files: 5  ~  Limite dimensione singolo file: 10MB  ~  Estensioni file ammesse: ',
    selloutFilesAdd: 'Carica file',
    selloutFilesDownload: 'Download',
    selloutFilesReplace: 'Sostituisci',
    quotationToolFile: 'Quotation tool (facoltativo)',
    quotationToolFile_desc: 'Carica il file quotation tool usato per questo preventivo.',
    quotationToolFile_desc2: 'Limite numero files: 1  ~  Limite dimensione singolo file: 10MB',
    purchaseOrderNumberSofia: 'Purchase Order Number to Sofia',
    baselineSubscription: 'Baseline Luckey Subscription',
    baselineSubscription_BASIC: 'Luckey Basic',
    baselineSubscription_ENTERPRISE: 'Luckey Enterprise (Standard)',
    baselineSubscription_ENGINE: 'Luckey Engine',
    baselineSubscription_undefined: 'Usa subscription custom',
    subscriptionData: 'Subscription info',
    noSubscriptionFound: 'Nessuna subscription trovata.',
    noSubscriptionFoundPleaseCheck: ' Controlla i campi ',
    selectedSubscription: 'Subscription selezionata: ',
    plantName: 'System Name',
    plantName_desc: 'Minuscolo, senza spazi e, se necessario, separato da trattini - es: example-plant-name.',
    keyAccountManager: 'Email Key Account Manager',
    keyAccountManager_desc: 'Indirizzo email del Key Account Manager',
    systemManagerEmails: 'Email System Administrator (una o più di una)',
    systemManagerEmails_desc: 'Indirizzo email della persona responsabile del controllo accessi per gli utenti sulla piattaforma web di gestione',
    installerEmail: 'Email installatore (facoltativo)',
    installerEmail_desc: '',
    pmEmail: 'Email PM (facoltativo)',
    pmEmail_desc: 'Deve appartenere a @sofialocks.com o @iseo.com',
    systemEngineerEmail: 'Email System Engineer (facoltativo)',
    systemEngineerEmail_desc: 'Deve appartenere a @sofialocks.com o @iseo.com',
    numberOfElements: 'Numero di elementi da gestire',
    numberOfElements_desc: 'Gli elementi sono la somma di: utenti, serrature ed inviti attivi',
    V364orF9000: 'Serrature V364/1RIS o cilindri F9000?',
    V364orF9000_desc: 'Sono presenti serrature V364/1RIS o cilindri F9000 nel sistema? In tal caso, verrà aggiunto automaticamente l\'addon relativo.',
    addons: 'Add-ons & Plug-ins',
    addons_desc: 'Seleziona gli add-ons da aggiungere alla baseline subscription',
    credits: 'Numero di crediti',
    credits_desc: 'Crediti venduti con questa attivazione',
    expectedEnd: 'Secondo le informazioni immesse, i crediti esauriranno in: ',
    finalData: 'Altre informazioni',
    notes: 'Note',
    notes_desc: 'Scrivi qui eventuali note aggiuntive riguardanti la richiesta di attivazione',
    notifications: 'Notifiche',
    notifications_desc: 'Persone da notificare per eventi riguardanti la richiesta; di default, il proprietario della richiesta ed il Key Account Manager saranno notificati',
    editBaselineSubscriptionWarning: 'Sei sicuro di voler cambiare la baseline subscription? Gli add-ons attualmente selezionati saranno resettati.',
    editBaselineSubscriptionError: 'Errore interno, per favore ripeti l\'operazione.',
    editNumberOfElementsWarning: 'Sei sicuro di voler cambiare il numero di elementi? Gli add-ons disponibili saranno resettati.',
    editNumberOfElementsError: 'Errore interno, per favore ripeti l\'operazione.',
    customerMarketplaceError: 'Il cliente selezionato non è associato ad un marketplace. Per favore, contattare l\'assistenza per risolvere il problema',
    customerClusterError: 'Il cliente selezionato non è associato ad un cluster. Per favore, contattare l\'assistenza per risolvere il problema',
    invoiceData: 'Fatturazione',
    invoiceFile: 'PDF fattura *',
    invoiceFile_desc: 'Carica il PDF della fattura.',
    invoiceFile_desc2: 'Limite numero files: 1  ~  Limite dimensione singolo file: 10MB',
    invoiceNumber: 'Numero e data fattura di sell-out (XXXXXX - DD/MM/YYYY)',
    invoiceNumberPlaceholder: 'XXXXXX - DD/MM/YYYY',
    setInvoiceData: 'Carica fattura',
    dataMissingCreated: 'Specifica numero e PDF fattura per procedere',
  },
  recharges: {
    recalculate: 'Ricalcola',
    restartRechargeJob: 'Riavvia calcolo',
    restartRechargeJobConfirm: 'Sei sicuro di voler riavviare il calcolo delle richieste di ricarica?',
    restartRechargeJobSuccess: 'Calcolo delle richieste di ricarica riavviato con successo',
    restartRechargeJobError: 'Si è verificato un errore nel riavvio del calcolo delle richieste di ricarica. Per favore riprova',
    addNewRechargeButton: 'Aggiungi richiesta ricarica',
    noRechargesFoundTitle: 'Nessuna richiesta trovata',
    noRechargesFoundDescription: 'Non ci sono richieste nel sistema. Creane di nuove per iniziare.',
    customerAndWallet: 'Cliente e wallet',
    seeCustomer: 'Info',
    seeCustomerDetails: 'Vedi dettagli cliente',
    selloutOrder: 'Ordine Sell-out',
    intragroupOrder: 'Ordine Intra-group',
    custref: 'Cust. Ref.',
    mode:'Tipologia rinnovo contrattuale:',
    creditsSuggested:'Crediti suggeriti',
    creditsConfirmed:'Crediti confermati',
    rejectedReason: 'Motivo di rifiuto',
    deletedReason: 'Motivo di eliminazione',
    createdAt: 'Data creazione',
    updatedAt: 'Data ultima modifica',
    customerSearch: 'Cerca tra i clienti esistenti',
    customerSearchEnterName: 'Cerca per nome...',
    customerSearchNoMatch: 'Nessun cliente trovato...',
    varCustomerSearch: 'Cerca tra i clienti del VAR',
    varSearch: 'Cerca tra i VAR esistenti',
    varSearchEnterName: 'Cerca per nome...',
    varSearchNoMatch: 'Nessun VAR trovato...',
    plantSearch: 'Seleziona il sistema di riferimento',
    plantSearchEnterName: 'Seleziona plant',
    plantSearchNoMatch: 'Nessun sistema trovato...',
    plantProceedWithSelected: 'Usa sistema/wallet selezionato',
    dataMissingTakenCharge: 'Specifica crediti confermati e ordine sell-out per procedere',
    dataMissingScratchcardCreated: 'Specifica numero e PDF fattura per procedere',
    changeStatusToSelloutOrderGenerated: 'Manda in revisione',
    changeStatusToInvoiced: 'Contrassegna fatturata',
    changeStatusToCreated: 'Contrassegna creata',
    changeStatusToRejected: 'Rifiuta richiesta',
    changeStatusToScratchcardCreated: 'Scratchcard creata',
    changeStatusToWalletRecharged: 'Wallet ricaricato',
    changeStatusAdmin: 'Imposta stato (admin)',
    createCard: 'Crea scratchcard',
    changeCustRef: 'Imposta Cust. Ref.',
    search: 'Cerca...',
    resetFilters: 'Resetta filtri',
    statusSelection: 'Qualsiasi stato',
    clusterSelection: 'Qualsiasi cluster',
    statusTO_BE_MANAGED: 'Da gestire',
    statusTAKEN_CHARGE: 'Presa in carico',
    statusREQUEST_TO_DELETE: 'Richiesta eliminazione',
    statusSELLOUT_ORDER_GENERATED: 'In revisione',
    statusSCRATCHCARD_CREATED: 'Scratchcard generata',
    statusWALLET_RECHARGED: 'Ricaricato',
    statusREJECTED: 'Rifiutato',
    statusDELETED: 'Eliminata',
    statusINVOICED: 'Fatturata',
    saveRequest: 'Salva richiesta',
    createRequest: 'Crea richiesta ricarica',
    takeCharge: 'Prendi in carico',
    AUTO_RENEWABLE: 'Rinnovabile automaticamente',
    NOT_AUTO_RENEWABLE: 'NON rinnovabile automaticamente',
    deleteRechargeConfirm: 'Sei sicuro di voler eliminare questa richiesta? Per favore, specifica il motivo dell\'eliminazione. L\'operazione non può essere annullata',
    deleteAdminRechargeConfirm: 'Sei sicuro di voler eliminare definitivamente questa richiesta? L\'operazione non può essere annullata',
    deleteRechargeError: 'Si è verificato un errore nella cancellazione della richiesta. Per favore riprova',
    takechargeRechargeConfirm: 'Specifica il tipo di rinnovo per procedere con la richiesta',
    takechargeRechargeDirectConfirm: 'Sei sicuro di voler prendere in carico questa richiesta?',
    takechargeRechargeError: 'Si è verificato un errore nella presa in carico della richiesta. Per favore riprova',
    promoteRechargeConfirm: 'Sei sicuro di voler mandare la richiesta in revisione? Non sarà più possibile modificare la richiesta',
    promoteRechargeError: 'Si è verificato un errore nella promozione della richiesta. Per favore riprova',
    createdRechargeConfirm: 'Sei sicuro di voler mandare la richiesta in stato CREATA?',
    createdRechargeError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    invoicedRechargeConfirm: 'Sei sicuro di voler segnare la richiesta come fatturata?',
    invoicedRechargeError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    editStatusRechargeConfirm: 'Sei sicuro di voler modificare lo stato di questa richiesta? L\'operazione non può essere annullata',
    editStatusRechargeError: 'Si è verificato un errore nella modifica stato della richiesta. Per favore riprova',
    rejectRechargeConfirm: 'Specifica le motivazioni per il rifiuto di questa richiesta.',
    rejectRechargeError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    scratchcardCreatedRechargeConfirm: 'Sei sicuro di voler accettare la richiesta e confermare di aver creato la scratchcard?',
    scratchcardCreatedRechargeError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    walletRechargedRechargeConfirm: 'Sei sicuro di voler completare la richiesta e confermare di aver ricaricato il wallet?',
    walletRechargedRechargeError: 'Si è verificato un errore nel cambio stato della richiesta. Per favore riprova',
    newFileName: 'Specifica il nome del file',
    newFileExtensionError: 'Il file selezionato ha un\'estensione non supportata',
    newFileDuplicateNameError: 'Questo nome è già stato usato per un altro file. Cambia il nome e ripeti l\'operazione.',
    editCustrefConfirm: 'Specifica il Cust. Ref. di questa richiesta.',
    editCustrefError: 'Si è verificato un errore nell\'aggiornamento del Cust. Ref., per favore riprova',
    editRecharge: 'Modifica richiesta ricarica',
    newRecharge: 'Aggiungi richiesta ricarica',
    viewRecharge: 'Visualizza richiesta ricarica',
    newRechargeError: 'Si è verificato un errore nella creazione della richiesta. Per favore riprova',
    editRechargeError: 'Si è verificato un errore nel salvataggio della richiesta. Per favore riprova',
    exportRechargesCSV: 'Esporta CSV',
    basicData: 'Parametri di ricarica wallet',
    ordersData: 'Ordini',
    invoiceData: 'Fatturazione',
    formEnterAnswer: 'La tua risposta',
    formEnterAnswerGT0: 'Numero maggiore di zero',
    sfdcId: 'ID Opportunità (SFDC)',
    salesOrderConfirmationNumber: 'Sales Order Confirmation Number (sell-out)',
    salesOrderConfirmationNumber_desc: '',
    selloutFiles: 'Sell-out order PDF (hardware + software + professional services)',
    selloutFiles_desc: 'Necessario per tracciare correttamente le revenues Blossom.',
    selloutFiles_desc2: 'Limite numero files: 5  ~  Limite dimensione singolo file: 10MB  ~  Estensioni file ammesse: ',
    selloutFilesAdd: 'Carica file',
    selloutFilesDownload: 'Download',
    selloutFilesReplace: 'Sostituisci',
    invoiceFile: 'PDF fattura *',
    invoiceFile_desc: 'Carica il PDF della fattura.',
    invoiceFile_desc2: 'Limite numero files: 1  ~  Limite dimensione singolo file: 10MB',
    invoiceNumber: 'Numero fattura di sell-out (al cliente) *',
    purchaseOrderNumberSofia: 'Purchase Order Number to Sofia',
    orderContactEmail: 'Email di contatto relativa all\'ordine',
  },
  vars: {
    varCategoryType: 'Tipologia',
    varCategoryType_VAR: 'VAR',
    varCategoryType_DEALER: 'Dealer',
    vashoManual: 'Guida Partners',
    partnerLevel: 'Livello partner',
    runningQuotations: 'Quotazioni in corso',
    activeCustomers: 'Clienti attivi',
    activeSystems: 'Sistemi attivi',
    monthlyCreditsBurnRate: 'Consumo mensile crediti',
    varHome: 'Home',
    candidatePartnerStepsAway: 'Devi firmare il contratto per diventare partner registrato',
    candidatePartnerStepsAwayDescription: 'Firma e invia l\'accordo VAR per diventare partner registrato',
    registeredPartnerStepsAway: 'Sei ad un passo da essere un partner registrato',
    registeredPartnerStepsAwayDescription: 'Firma e invia l\'accordo VAR per diventare partner registrato',
    preferredPartner: 'Sei classificato come partner preferito!',
    preferredPartnerDescription: 'Sei ora visibile nel nostro sito web come partner preferito',
    preferredPartnerStepsAway: 'Sei a {{steps}} passi da essere un partner preferito',
    preferredPartnerStepsAwayDescription: 'Per essere visibile nel nostro sito web come partner preferito, devi completare i passi rimanenti',
    partnerLevelContractSigned: 'Contratto firmato',
    partnerLevelRebateLetterSigned: 'Lettera di rebate firmata',
    partnerLevelTrainingCompleted: 'Training completato',
    partnerLevelDemoKitPurchased: 'Kit demo acquistato',
    partnerLevelQuotationRequested: 'Quotazione richiesta',
    partnerLevelOneActiveCustomer: 'Un cliente attivo',
    varDocumentHistoryRebateLetter: 'Storico file',
    varDocumentHistoryAgreement: 'Storico file',
    varDocumentHistoryDate: 'Data sostituzione',
    syncsfdcidVarOpportunitySuccess: 'Richiesta presa in carico. Per favore verifica la corrispondente opportunità in Salesforce',
    varLogo: 'Logo',
    setTrainingDate: 'Imposta data',
    missingLastTrainingDateForCertificate: 'Il VAR non ha una data di training impostata. Per favore imposta la data di ultimo training e riprova a generare il certificato',
    expiredLastTrainingDateForCertificate: 'Il training del VAR è scaduto. Per favore aggiorna la data di training e riprova a generare il certificato',
    varLastTrainingData: 'Data ultimo training',
    varShortDescription: 'Breve descrizione',
    varLastTrainingDataExpirationDate: 'Data scadenza training',
    rebateLetterFile: 'Lettera di rebate',
    varRebateLetterFileExpirationDate: 'Scadenza lettera di rebate',
    varAgreementFileExpirationDate: 'Data scadenza accordo',
    varDemoKitPurchaseDate: 'Data acquisto kit demo',
    varDemoKitOrderNumber: 'Numero ordine kit demo',
    varCity: 'Città',
    varCountry: 'Paese',
    varWebsite: 'Sito web',
    varVisibleOnSofiaWebsite: 'Visibile nella sezione partners del sito Sofia',
    downloadCertificate: 'Scarica certificato',
    opportunityChangeOwnerMessage: 'Specifica il proprietario di questa quotazaione',
    noOpportunityHistoryFound: 'Nessuno storico trovato',
    noOpportunityHistoryFoundDescription: 'Questa quotazione non ha alcun record storico da mostrare',
    customers: 'Clienti',
    varsManagement: 'VARs',
    varSettings: 'Impostazioni',
    varInfoPage: 'Training & Risorse',
    varUsersPage: 'Utenti',
    vars: 'VAR',
    plantThemes: 'Temi personalizzati',
    editVarPersonalConfirm: 'Stai modificando i dati aziendali, sei sicuro di voler procedere?',
    editVarConfirm: 'Stai modificando l\'anagrafica VAR, sei sicuro di voler procedere?',
    editVar: 'Modifica VAR',
    newVar: 'Nuovo VAR',
    varCreationConfirm: 'Sei sicuro di voler creare il nuovo VAR?',
    createVar: 'Crea VAR',
    noVarFindTitle: 'Nessun VAR trovato',
    noVarFindDescription: 'La lista dei VAR è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    noPlantThemeFindTitle: 'Nessun tema personalizzato trovato',
    noPlantThemeFindDescription: 'La lista dei temi personalizzati è vuota. Se hai impostato un filtro di ricerca prova a modificarlo e riprovare',
    clusterSelection: 'Qualsiasi cluster',
    varSelection: 'Qualsiasi VAR',
    varName: 'Nome',
    varAddress: 'Indirizzo',
    varEmail: 'Email contatto principale',
    varPhone: 'Telefono',
    varCluster: 'Cluster',
    varVat: 'P. IVA',
    varNameTech: 'Nome riferimento tecnico',
    varEmailTech: 'Email riferimento tecnico',
    varPhoneTech: 'Telefono riferimento tecnico',
    varNameComm: 'Nome riferimento commerciale',
    varEmailComm: 'Email riferimento commerciale',
    varPhoneComm: 'Telefono riferimento commerciale',
    varTechContact: 'Riferimento tecnico',
    varCommercialContact: 'Riferimento commerciale',
    varSfdcid: 'SFDC ACCOUNT ID',
    varSupportEmail: 'Support: email',
    varSupportHours: 'Support: orario di apertura',
    varCompanyName: 'Nome azienda',
    varCustomers: 'Clienti del VAR',
    varUsers: 'Utenti del VAR',
    varOpportunities: 'Quotazioni del VAR',
    editPlantThemeConfirm: 'Stai modificando i dati del tema personalizzato, sei sicuro di voler procedere?',
    editPlantTheme: 'Modifica tema personalizzato',
    newPlantTheme: 'Nuovo tema personalizzato',
    plantThemeCreationConfirm: 'Sei sicuro di voler creare questo nuovo tema personalizzato?',
    editVarPersonal: 'Modifica informazioni aziendali',
    plantThemeName: 'Nome',
    plantThemeColour: 'Colore *',
    plantThemeColourDescription: 'Colore tema',
    plantThemeLogo: 'Logo',
    plantThemeDefault: 'Usa come predefinito',
    logoFile: 'Immagine logo *',
    logoFile_desc: 'Estensioni ammesse: ',
    logoFileAdd: 'Carica file',
    logoFileDownload: 'Download',
    logoFileReplace: 'Sostituisci',
    deletePlantThemeConfirm: 'Sei sicuro di voler eliminare questo tema personalizzato? L\'operazione non può essere annullata',
    plantThemeSearchEnterName: 'Seleziona tema',
    plantThemeSearch: 'Seleziona il tema da impostare',
    domainThemeTitle: 'Tema personalizzato',
    domainThemeDescription: 'Imposta il tuo tema personalizzato su questo dominio',
    plantThemeModifySuccess: 'Configurazioni tema personalizzato modificate e aggiornate',
    cannotDeleteAssociatedTheme: 'Impossibile eliminare un tema personalizzato che è attualmente associato ad un impianto.',
    plantThemeAssociatedPlants: 'Impianti associati a questo tema',
    newVarUser: 'Nuovo utente VAR',
    varUserCreationConfirm: 'Vuoi creare il nuovo utente VAR?',
    createVarUser: 'Crea utente VAR',
    varUserFormTitle: 'Utente VAR',
    createNewVarUser: 'Crea nuovo utente VAR',
    noVarUserFindTitle: 'Nessun utente VAR',
    noVarUserFindDescription: 'La lista degli utenti VAR è vuota',
    deleteVarUserConfirm: 'Sei sicuro di voler eliminare questo utente VAR? L\'operazione non può essere annullata',
    deleteVarOpportunityConfirm: 'Sei sicuro di voler eliminare questa quotazione? L\'operazione non può essere annullata',
    rejectVarOpportunityConfirm: 'Sei sicuro di voler rifiutare questa quotazione? L\'operazione non può essere annullata',
    approveVarOpportunityConfirm: 'Sei sicuro di voler approvare questa quotazione? L\'operazione non può essere annullata',
    syncsfdcidVarOpportunityConfirm: 'Sei sicuro di voler associare un SFDC ID a questa quotazione? L\'operazione non può essere annullata',
    upgradeVarOpportunityConfirm: 'Sei sicuro di voler mandare questa quotazione in revisione? L\'operazione non può essere annullata',
    winVarOpportunityConfirm: 'Sei sicuro di voler impostare questa quotazione come VINTA? L\'operazione non può essere annullata',
    lostVarOpportunityConfirm: 'Sei sicuro di voler impostare questa quotazione come PERSA? L\'operazione non può essere annullata',
    deleteUserConfirm: 'Sei sicuro di voler eliminare questo utente? L\'operazione non può essere annullata',
    varUserUsername: 'Username',
    varUserFirstname: 'Nome',
    varUserLastname: 'Cognome',
    varUserEmail: 'Email',
    varUsersList: 'Utenti',
    newFileExtensionError: 'Il file selezionato ha un\'estensione non supportata',
    agreementFile: 'Accordo',
    opportunities: 'Quotazioni',
    opportunityManagement: 'Dati quotazione',
    opportunityID: 'ID',
    opportunityOpty: 'SFDC OPTY ID',
    opportunityVar: 'VAR',
    opportunityCustomer: 'Cliente',
    opportunityOwner: 'Owner',
    opportunityName: 'Nome quotazione',
    opportunityValue: 'Valore',
    opportunityStatus: 'Stato',
    opportunityActions: 'Azioni',
    opportunityDescription: 'Descrizione',
    opportunityNotes: 'Note',
    opportunityCrm: 'CRM',
    noOpportunityFindTitle: 'Nessuna quotazione',
    noOpportunityFindDescription: 'La lista delle quotazioni è vuota',
    opportunityStatus_DRAFT: 'Bozza',
    opportunityStatus_ON_APPROVAL: 'In approvazione',
    opportunityStatus_APPROVED: 'Approvata',
    opportunityStatus_CANCELLED: 'Cancellata',
    opportunityStatus_REJECTED: 'Rifiutata',
    opportunityStatus_WON: 'Vinta',
    opportunityStatus_LOST: 'Persa',
    opportunityFiles: 'Allegati',
    newOpportunity: 'Nuova quotazione',
    editOpportunity: 'Modifica quotazione',
    opportunitySyncSFDC: 'Sync with SFDC',
    exportOpportunities: 'Esporta CSV',
    upgradeOpportunity: 'Manda in revisione',
    approveOpportunity: 'Approva',
    rejectOpportunity: 'Rifiuta',
    wonOpportunity: 'Imposta come VINTA',
    lostOpportunity: 'Imposta come PERSA',
    CREATED: 'Quotazione creata',
    VAR_USER_UPDATED: 'VAR assegnato alla quotazione modificato',
    DESCRIPTION_UPDATED: 'Descrizione quotazione aggiornata',
    NAME_UPDATED: 'Nome quotazione aggiornato',
    VALUE_UPDATED: 'Valore quotazione aggiornato',
    CURRENCY_UPDATED: 'Valuta quotazione aggiornata',
    OPTY_ID_UPDATED: 'Opty id quotazione aggiornato',
    ISEO_CRM_ID_UPDATED: 'SFDC ID quotazione aggiornato',
    DOCUMENTS_UPDATED: 'Documento quotazione aggiornata',
    STATUS_ON_APPROVAL: 'Quotazione inviata per approvazione',
    STATUS_APPROVED: 'Quotazione approvata',
    STATUS_WON: 'Quotazione marcata come vinta',
    STATUS_LOST: 'Quotazione marcata come persa',
    STATUS_REJECTED: 'Quotation marcata come rifiutata',
    STATUS_DRAFT: 'Quotation marcata come in bozza',
    STATUS_CANCELLED: 'Quotation marcata come cancellata',
    CANCELLED: 'Quotazione cancellata',
    showOpportunityHistory: 'Mostra storico',
    opportunityHistory: 'Storico quotazione'
  },
  language: "Lingua",
  languages: {
    it: "Italiano",
    en: "Inglese",
    de: "Tedesco",
    fr: "Francese",
    es: "Spagnolo",
    nl: "Olandese",
    ITALIAN: "Italiano",
    ENGLISH: "Inglese",
    GERMAN: "Tedesco",
    FRENCH: "Francese",
    SPANISH: "Spagnolo",
    DUTCH: "Olandese",
    menuHeading: "Scegli una lingua",
  },
  productInfo: {
    software: 'Software',
    salesMaterial: 'Materiale commerciale',
    hardware: 'Hardware',
    marketingMaterial: 'Materiale Marketing',
  },
  users: {
    usersManagement: 'Gestione utenti',
    users: 'Utenti',
    noUserFindTitle: 'Nessun utente trovato',
    noUserFindDescription: 'La lista utenti è vuota. Prova a modificare i filtri di ricerca se impostati',
    search: 'Cerca...',
    roleSelection: 'Role',
    clusterSelection: 'Cluster',
    varSelection: 'VAR',
    newUser: 'Crea',
    userFirstname: 'Nome',
    userLastname: 'Cognome',
    userEmail: 'Email',
    userFormTitle: 'Dati utente',
    editUserForm: 'Modifica utente',
    newUserForm: 'Crea utente',
  },
  permissions: {
    CSV_IMPORT: 'Gestisci Importazioni Sistemi Master Key',  
    CREATE_REQUEST: 'Crea Richieste',
    MANAGE_REQUEST: 'Gestisci Richieste',
    EXPORT_REQUESTS: 'Esporta Richieste',
    MKS: 'Gestione sistemi Master Key',
    SEARCH_BY_DOMAIN: 'Cerca per dominio',
    SELLOUT_GENERATED: 'Sellout generato',
    INVOICED: 'Fatturato',
    MARK_UNDER_REVIEW: 'Marcare entità come In revisione',
    NAVIGATION: 'Visibilità menu',
    CLUSTER: 'Cluster',
    VAR: 'VAR',
    CUSTOMER: 'Clienti',
    OPPORTUNITY: 'Quotazioni',
    WALLET: 'Wallet dei clienti',
    DOMAIN: 'Domini dei clienti',
    GATEWAYS: 'Gateway',
    CARD: 'Ricariche',
    PLANT_ACTIVATION: 'Attivazioni sistemi',
    RECHARGE_REQUEST: 'Richieste di ricarica',
    ACTIVATION_REQUEST: 'Richieste di attivazione',
    EXPORT: 'Esportare le entità',
    CREATE: 'Creare nuova entità',
    UPDATE: 'Aggiornare entità',
    MARK_LOST: 'Marcare entità come Persa',
    MARK_WON: 'Marcare entità come Vinta',
    CANCEL: 'Marcare entità come Cancellata',
    CANCEL_DRAFT: 'Marcare entità come Cancellata quando in bozza',
    CANCEL_ON_APPROVAL: 'Marcare entità come Cancellata quando sotto revisione',
    CANCEL_APPROVED: 'Marcare entità come Cancellata quando approvata',
    MARK_TO_BE_APPROVED: 'Marcare entità come Approvata',
    RECHARGE: 'Ricaricare',
    SUBSCRIPTION_UPDATE: 'Aggiornare subscriptions',
    DELETE_REQUEST: 'Inviare richiesta di cancellazione',
    CREATION_REQUEST: 'Inviare richiesta di creazione',
    MANAGER_CREATE: 'Creare amministratori',
    MANAGER_UPDATE: 'Aggiornare amministratori',
    INSTALLER_CREATE: 'Creare installatori',
    INSTALLER_UPDATE: 'Aggiornare installatori',
    IMPERSONATE_WRITE: 'Impersonare amministratori',
    IMPERSONATE_SUPPORT: 'Impersonare account support',
    ADDITIONAL_INFO_UPDATE: 'Modificare informazioni aggiuntive',
    CUSTOMERS: 'Clienti',
    PLANT_ACTIVATIONS: 'Attivazioni sistemi',
    RECHARGE_REQUESTS: 'Richieste di ricarica',
    ACTIVATION_REQUESTS: 'Richieste di attivazioni',
    CARDS: 'Ricariche',
    VAR_USERS: 'Utenti VAR',
    VAR_SETTINGS: 'Impostazioni VAR',
    OPPORTUNITIES: 'Quotazioni',
    PRODUCTINFO: 'Informazioni prodotto',
    USER_READ: 'Vedere utenti',
    USER_UPDATE: 'Aggiornare utenti',
    USER_CREATE: 'Creare utenti',
    PLANT_THEME: 'Cambiare tema dominio',
    READ: 'Leggere valori entità',
    ORDERS_STATUS: 'Stato ordini',
    FILTER: 'Filtrare entità',
    VAR_MANAGEMENT: 'Gestione VAR',
    MARKETPLACES: 'Marketplaces',
    DOMAINS: 'Domini dei clienti',
    PRICELIST: 'Price list',
    SALESINFO: 'Sales info',
    PLATFORM_USERS: 'Gestione utenti',
    APPROVE: 'Marcare entità come Approvata',
    REJECT: 'Marcare entità come Rifiutata',
    EXTEND: 'Estendere entità',
    CONFIG: 'Leggere configurazioni',
    IRIS_ENABLE: 'Abilitare 1RIS per il dominio',
    MARK_TO_PROMOTE: 'Marcare entità come In revisione',
    MARK_TO_INVOCE: 'Marcare entità come Da Fatturare',
    DELETE: 'Cancellare entità',
    EDIT: 'Aggiornare entità',
    SUBSCRIPTION_DELETE: 'Rimuovere subscriptions',
    VAR_HOMEPAGE: 'Pagina VAR',
    CHANGE_OWNER: 'Cambia proprietario',
    CONTRACTS: 'Contratti',
    CONTRACT_SERVICES: 'Servizi contratti',
    DOWNLOAD_CERTIFICATE: 'Scarica certificato',
    PLANTS_READ: 'Leggere sistemi',
    PLANTS_UPDATE: 'Aggiornare sistemi',
    PLANTS_CREATE: 'Creare sistemi',
    PLANTS_DELETE: 'Eliminare sistemi',
    SYNC_SFDCID: 'Sync con SFDC',
    UPDATE_ADMIN: 'Aggiornare amministratori',
    HISTORY_READ: 'Leggere storico',
    UPDATE_LOGO: 'Aggiornare logo',
    EXPORT_ALL_MANAGERS: 'Esportare tutti gli amministratori',
    LEGACY_DOMAINS_READ: 'Leggere domini legacy',
    TAKE_CHARGE: 'Prendere in carico',
    EDIT_ADMIN: 'Modificare amministratori',
    DEMO_READ: 'Leggere sistemi demo',
    DEMO_CREATE: 'Creare sistemi demo',
    DEMO_UPDATE: 'Aggiornare sistemi demo',
    DEMO_DELETE: 'Eliminare sistemi demo',
    DEMO_MANAGEMENT: 'Gestione sistemi demo',
  },
  segmentTypes: {
    WORKING_SPACES_name: 'Flexible Working Space',
    LIVING_name: 'Flexible Living',
    RETAIL_name: 'Flexible Retail',
    UNIVERSITIES_name: 'Universities',
    LEISURE_name: 'Leisure and Hospitality',
    HOSPITAL_name: 'Hospital',
    WORKING_SPACES_description: 'Offices, Coworking, Business centers',
    LIVING_description: 'Residential, Co-housing, Co-living, Student housing',
    RETAIL_description: 'Multi-site retail, Shopping malls, Shops chains',
    LEISURE_description: 'Small and Medium Hotels, Accommodation, Sport centers',
    HOSPITAL_description: 'Hospitals, Senior Living and elderly care',
    deprecated: 'OLD',
    ESTATE_WORKPLACES_REAAS_name: 'Estate - Workplaces - ReaaS [Coworking, Proworking, Business Centers]',
    ESTATE_WORKPLACES_BTR_name: 'Estate - Workplaces - BTR [Single company offices, Hybrid Workplaces, Multi-tenant office buildings, Business Parks]',
    ESTATE_RESIDENTIAL_REAAS_name: 'Estate - Residential - ReaaS [Coliving, Student housing (PBSA), Senior Housing]',
    ESTATE_RESIDENTIAL_BTR_name: 'Estate - Residential - BTR [Multifamily housing, Condos]',
    ESTATE_RESIDENTIAL_BTS_name: 'Estate - Residential - BTS [Multifamily housing, Condos, Cohousing]',
    ESTATE_EDUCATION_name: 'Estate - Education [Schools, Universities]',
    ESTATE_SPORT_FACILITIES_name: 'Estate - Sport Facilities [Arenas, Football stadiums, Tennis courts]',
    ESTATE_MUNICIPALITIES_name: 'Estate - Municipalities [Townhalls, Public Offices]',
    ESTATE_HEALTHCARE_name: 'Estate - Healthcare [Hospitals, Elderly care facilities]',
    ESTATE_RETAIL_MULTI_SITE_name: 'Estate - Retail - Multi site [Pharmacies, Postal Offices, Banks, DIY stores, Fashion, Private clinics]',
    ESTATE_HOSPITALITY_PROFESSIONAL_name: 'Estate - Hospitality - Professional [Big hotels]',
    ESTATE_HOSPITALITY_SMALL_name: 'Estate - Hospitality - Small [Small Hotels, B&Bs, Camping sites]',
    UTILITIES_TELECOM_name: 'Utilities - Telecom [Infrastructure, Operartors]',
    UTILITIES_ELECTRICITY_name: 'Utilities - Electricity [Production, Distribution]',
    'UTILITIES_OIL&GAS_name': 'Utilities - Oil&Gas [Pipes, Transportation]',
    UTILITIES_WATER_name: 'Utilities - Water [Purification, Distribution, Wastewater treatment]',
    UTILITIES_WASTE_name: 'Utilities - Waste [Bio Hazard]',
    UTILITIES_TRANSPORTATION_name: 'Utilities - Transportation [Railways, Subway, Roads, Airports]',
    DEMO_name: 'Demo',
  },
  demoSystem: {
    title: 'I miei impianti demo',
    name: 'Nome',
    notes: 'Note',
    url: 'URL',
    peopleUsing: 'Persona assegnata',
    openNow: 'Apri ora',
    noDataTitle: 'Nessun impianto demo trovato',
    noDataDescription: 'Non ci sono impianti demo disponibili al momento',
    newDemoPlantAssociation: 'Assegna impianto demo',
    demoPlantAssociationCompleted: 'Impianto demo assegnato con successo',
    createDemoPlantAssociationError: 'Si è verificato un errore durante l\'assegnazione dell\'impianto demo. Si prega di riprovare',
    deleteDemoPlantAssociation: 'Sei sicuro di voler eliminare questa associazione?',
    deleteDemoPlantAssociationConfirm: 'Associazione eliminata con successo',
    deleteDemoPlantAssociationError: 'Si è verificato un errore durante l\'eliminazione dell\'associazione. Si prega di riprovare',
    demoPlantAssociationEditedCompleted: 'Associazione modificata con successo',
    editDemoPlantAssociationError: 'Si è verificato un errore durante la modifica dell\'associazione. Si prega di riprovare',
    demoSystemsTitle: 'Impianti demo',
  },
  agreements: {
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Termini e Condizioni',
    acceptAgreements: 'Accetta',
    agreementsUpdated: 'Accordi Aggiornati',
    pleaseAcceptAgreements: 'Accetta gli accordi aggiornati per continuare',
    errorAcceptTermsAndPrivacy: 'Errore durante l\'accettazione dei termini e della privacy',
  },
  mks: {
    yourRoleDoesNotHavePermissionToImportCsv: 'Il tuo ruolo non ha permesso di importare file CSV MKS. Si prega di verificare le tue autorizzazioni e riprovare.',
    status_COMPLETED: 'Precedente',
    status_CURRENT: 'Attuale',
    status_ERROR: 'Errore',
    requestType: 'Tipo Richiesta',
    selectFileFormat: 'Seleziona formato file',
    importFileFormat_LOCKBASE: 'Lockbase',
    importFileFormat_SUPERLOCK: 'Superlock',
    importFileFormat: 'Formato File Importazione',
    mksTitle: 'Sistemi Master Key',
    cylindersTitle: 'Cilindri',
    keysTitle: 'Chiavi',
    keyDetails: 'Dettaglio chiave',
    cylinderDetails: 'Dettaglio cilindro',
    hostnameRequiredForImportDescription: 'Inserisci il nome di un impianto per importare i dati',
    id: 'ID',
    externalId: 'ID Esterno',
    doorName: 'Nome Porta',
    marking: 'Marcatura',
    type: 'Tipo',
    insideLength: 'Lunghezza Interna',
    outsideLength: 'Lunghezza Esterna',
    quantity: 'Quantità',
    quantityKeys: 'Quantità Chiavi',
    keyFunction: 'Funzione Chiave',
    designation: 'Designazione',
    companyId: 'ID Azienda',
    hostnameRequired: 'Nome Impianto (obbligatorio)',
    hostnameRequiredTitle: 'Impianto Richiesto',
    hostnameRequiredDescription: 'Inserisci un nome di impianto per visualizzare l\'elenco',
    noCylindersFoundTitle: 'Nessun Cilindro Trovato',
    noCylindersFoundDescription: 'Non sono stati trovati cilindri per l\'impianto specificato',
    noKeysFoundTitle: 'Nessuna Chiave Trovata',
    noKeysFoundDescription: 'Non sono state trovate chiavi per l\'impianto specificato',
    filterByType: 'Tipo Cilindro',
    filterByDoorName: 'Nome Porta',
    filterByKeyFunction: 'Funzione Chiave',
    filterByDesignation: 'Designazione Chiave',
    importsTitle: 'Importazioni',
    noImportsFoundTitle: 'Nessuna Importazione Trovata',
    noImportsFoundDescription: 'Non sono state trovate importazioni per l\'impianto specificato',
    filterByStatus: 'Stato Importazione',
    filterByFilename: 'Nome File',
    uploadCsv: 'Carica file',
    uploadCsvTitle: 'Carica File',
    dragDropCsv: 'Trascina e rilascia il tuo file qui',
    orClickToSelect: 'oppure clicca per selezionare un file',
    previewCsv: 'Anteprima file',
    csvPreviewTitle: 'Anteprima Importazione',
    previewSummary: 'Riepilogo Importazione',
    csvHasErrors: 'Il file contiene errori di validazione. Verranno importate solo le righe valide.',
    validationErrors: 'Errori di Validazione',
    dataPreview: 'Anteprima Dati',
    noValidRowsToImport: 'Nessuna riga valida trovata per l\'importazione. Correggi gli errori e riprova.',
    confirmImport: 'Conferma Importazione',
    fileInfo: 'Informazioni File',
    importSummary: 'Riepilogo Importazione',
    filename: 'Nome File',
    importTimestamp: 'Data Importazione',
    status: 'Stato',
    keysImported: 'Chiavi Importate',
    cylindersImported: 'Cilindri Importati',
    relationsImported: 'Relazioni Importate',
    errorsCount: 'Conteggio Errori',
    userEmail: 'Email Utente',
    noKeySelected: 'Nessuna chiave selezionata',
    noCylinderSelected: 'Nessun cilindro selezionato',
    customAttributes: 'Attributi Personalizzati',
    associatedCylinders: 'Cilindri Associati',
    associatedKeys: 'Chiavi Associate',
    noAssociatedCylinders: 'Nessun cilindro associato trovato',
    noAssociatedKeys: 'Nessuna chiave associata trovata',
    relationId: 'ID Relazione',
    fileSize: 'Dimensione File',
    totalRows: 'Righe Totali',
    errors: 'Errori',
    keys: 'Chiavi',
    cylinders: 'Cilindri',
    relations: 'Relazioni',
    currentConfig: 'Configurazione Attuale',
    confirmImportTitle: 'Conferma Import',
    confirmImportMessage: 'Sei sicuro di voler importare questo file?',
    fileName: 'Nome File',
    warningMessage: 'ATTENZIONE: Questa operazione sovrascriverà completamente la configurazione attuale dell\'impianto con i dati di questo file CSV. Questa operazione non è reversibile.',
    comparisonTitle: 'Confronto con la Configurazione Attuale',
    currentLabel: 'Attuale',
    newLabel: 'Nuova',
    requestsTitle: 'Richieste MKS',
    newRequest: 'Nuova Richiesta',
    editRequest: 'Modifica Richiesta',
    requestManagement: 'Gestione Richieste',
    requestType_KEY_DUPLICATION: 'Duplicazione Chiave',
    requestType_CYLINDER_DUPLICATION: 'Duplicazione Cilindro',
    requestType_KEY_EXTENSION: 'Estensione Chiave',
    requestType_CYLINDER_EXTENSION: 'Estensione Cilindro',
    requestStatus: 'Stato',
    requestStatus_DRAFT: 'Bozza',
    requestStatus_SENT: 'Inviata',
    requestStatus_TAKEN_IN_CHARGE: 'Preso in Carico',
    requestStatus_REJECTED: 'Rifiutata',
    requestStatus_CANCELED: 'Annullata',
    requestStatus_ORDER_CONFIRMED: 'Ordine Confermato',
    requestStatus_ORDER_SHIPPED: 'Ordine Spedito',
    requestStatus_ORDER_COMPLETED: 'Ordine Completato',
    historyAction_CREATED: 'Creata',
    historyAction_UPDATED: 'Aggiornata',
    historyAction_STATUS_CHANGED: 'Stato Cambiato',
    historyAction_STATUS_DRAFT: 'Stato Bozza',
    historyAction_STATUS_SENT: 'Stato Inviata',
    historyAction_STATUS_TAKEN_IN_CHARGE: 'Stato Preso in Carico',
    historyAction_STATUS_REJECTED: 'Stato Rifiutata',
    historyAction_STATUS_ORDER_CONFIRMED: 'Stato Ordine Confermato',
    historyAction_STATUS_ORDER_SHIPPED: 'Stato Ordine Spedito',
    historyAction_STATUS_ORDER_COMPLETED: 'Stato Ordine Completato',
    historyAction_STATUS_CANCELED: 'Stato Annullata',
    historyAction_NOTES_UPDATED: 'Note Aggiornate',
    historyAction_DELIVERY_DATE_UPDATED: 'Data Consegna Aggiornata',
    historyAction_DOCUMENTS_ADDED: 'Documenti Aggiunti',
    historyAction_DOCUMENTS_REMOVED: 'Documenti Rimossi',
    historyAction_CANCELLED: 'Annullata',
    historyAction_COMPLETED: 'Completata',
    requestNotes: 'Note',
    requestData: 'Dati Richiesta (JSON)',
    plantHostname: 'Hostname Impianto',
    companyName: 'Azienda',
    createdBy: 'Creato Da',
    deliveryDate: 'Data Consegna',
    plantSearch: 'Cerca Impianto',
    plantSearchNoMatch: 'Nessun impianto trovato',
    plantSearchEnterName: 'Inserisci hostname per cercare',
    selectRequestType: 'Seleziona Tipo Richiesta',
    requestTypeFilter: 'Filtra per Tipo',
    statusFilter: 'Filtra per Stato',
    sendRequest: 'Invia Richiesta',
    takeInCharge: 'Prendi in Carico',
    rejectRequest: 'Rifiuta',
    confirmOrder: 'Conferma Ordine',
    shipOrder: 'Spedisci Ordine',
    completeOrder: 'Completa Ordine',
    deleteMKSRequestConfirm: 'Sei sicuro di voler annullare questa richiesta?',
    changeStatusMKSRequestConfirm: 'Sei sicuro di voler cambiare lo stato di questa richiesta?',
    requestHistory: 'Cronologia Richiesta',
    noRequestHistoryFound: 'Nessuna Cronologia Trovata',
    noRequestHistoryFoundDescription: 'Nessun record di cronologia trovato per questa richiesta',
    noRequestFindTitle: 'Nessuna Richiesta Trovata',
    noRequestFindDescription: 'Nessuna richiesta MKS trovata. Prova ad aggiustare i filtri di ricerca.',
    exportRequests: 'Esporta Richieste',
    createMKSRequestConfirm: 'Sei sicuro di voler creare questa nuova richiesta MKS?',
    editMKSRequestConfirm: 'Sei sicuro di voler modificare questa richiesta MKS?',
    openMKSRequestsError: 'Si è verificato un errore durante il caricamento delle richieste MKS. Riprova',
    createMKSRequestError: 'Si è verificato un errore durante la creazione della richiesta. Riprova',
    editMKSRequestError: 'Si è verificato un errore durante l\'aggiornamento della richiesta. Riprova',
    deleteMKSRequestError: 'Si è verificato un errore durante l\'annullamento della richiesta. Riprova',
    changeMKSRequestStatusError: 'Si è verificato un errore durante il cambio di stato della richiesta. Riprova',
    seePlant: 'Vedi Impianto',
    customerName: 'Nome Cliente',
    varName: 'Nome VAR',
    length: 'Lunghezza',
    cylindersList: 'Lista Cilindri',
    cylindersData: 'Dati Cilindri (JSON)',
    keysList: 'Lista Chiavi',
    keysData: 'Dati Chiavi (JSON)',
    assignedUser: 'Utente Assegnato',
    selectAssignedUser: 'Seleziona Utente Assegnato',
    selectCylinders: 'Seleziona Cilindri',
    selectKeys: 'Seleziona Chiavi',
    requestFiles: 'File Richiesta',
    rejectedNotes: 'Note di Rifiuto',
    setDeliveryDateConfirm: 'Imposta la data di consegna per questo ordine',
    editDeliveryDate: 'Modifica Data di Consegna',
    editDeliveryDateConfirm: 'Aggiorna la data di consegna per questo ordine',
    rejectRequestConfirm: 'Fornisci un motivo per il rifiuto di questa richiesta',
    errorRejectRequest: 'Errore nel rifiutare la richiesta',
    saveRequestConfirmation: 'Salva Richiesta',
    saveRequestConfirmationMessage: 'Vuoi salvare la richiesta in bozza o inviarla adesso?',
    saveRequestConfirmationConfirm: 'Invia Ora',
    saveRequestConfirmationCancel: 'Salva come Bozza',
    createDuplicateKeyRequest: 'Crea Richiesta Duplicazione Chiave',
    createDuplicateCylinderRequest: 'Crea Richiesta Duplicazione Cilindro',
    selectCylinder: 'Seleziona Cilindro',
    selectKey: 'Seleziona Chiave',
    relationsMatrixTitle: 'Matrice Relazioni',
    cylinderName: 'Nome Cilindro',
    noRelationsFoundTitle: 'Nessuna Relazione Trovata',
    noRelationsFoundDescription: 'Non sono state trovate relazioni cilindro-chiave per l\'impianto specificato',
    selectedKey: 'Chiave Selezionata',
    selectedCylinder: 'Cilindro Selezionato',
    selectedKeys: 'Chiavi Selezionate',
    plantSearchPlaceholder: 'Cerca un sistema',
    keysDuplicates: 'Duplicati Chiavi',
    cylindersDuplicates: 'Duplicati Cilindri',
    addKey: 'Aggiungi Chiave',
    addCylinder: 'Aggiungi Cilindro',
    duplicateEntry: 'Voce Duplicato',
    duplicateKey: 'Chiave Duplicata',
    duplicateCylinder: 'Cilindro Duplicato',
    noKeysSelected: 'Nessuna chiave selezionata',
    noCylindersSelected: 'Nessun cilindro selezionato',
    quantityError: 'La quantità deve essere un intero maggiore di zero',
    batchAdd: 'Aggiungi in Batch',
    batchAddTitleCylinders: 'Aggiungi Cilindri in Batch',
    batchAddTitleKeys: 'Aggiungi Chiavi in Batch',
    batchAddFilterCylinders: 'Filtra cilindri',
    batchAddFilterKeys: 'Filtra chiavi',
    batchAddConfirm: 'Conferma',
    batchAddCancel: 'Annulla',
    batchAddNoResults: 'Nessun elemento trovato',
    batchAddTooManyResults: 'Troppi risultati (più di {{limit}}). Per favore affina il filtro di ricerca.',
    alreadySelected: 'Già selezionato',
    openAdvancedSelector: 'Apri Selettore Avanzato',
    selectCylindersWithCount: 'Seleziona Cilindri ({{count}})',
    selectKeysWithCount: 'Seleziona Chiavi ({{count}})',
    selectedItemsCount: '{{count}} elementi selezionati',
    itemsWillBeAdded: '{{count}} elementi verranno aggiunti',
    addItems: 'Aggiungi Elementi ({{count}})',
    generatePdf: 'Genera PDF',
    requestPdf: 'PDF Richiesta',
    pdfGenerationError: 'Si è verificato un errore durante la generazione del PDF. Riprova',
    generateXlsx: 'Genera Excel',
    xlsxGenerationError: 'Si è verificato un errore durante la generazione del file Excel. Riprova',
    generateDocx: 'Genera Word',
    docxGenerationError: 'Si è verificato un errore durante la generazione del documento Word. Riprova',
    exportRequest: 'Esporta Richiesta',
    field: 'Campo',
    value: 'Valore',
  },
  developers: {
    integrationInfo: 'Informazioni',
    api: 'API',
    sdk: 'SDK',
    knx: 'KNX',
    developersResource: 'Risorse sviluppatori',
  },
  iseo: {
    trainingMaterials: 'Materiali formativi ISEO',
  },
  iseoSalesApps: {
    launchpadMissingToken: 'Impossibile leggere il token di sessione Vasho. Accedi di nuovo e apri Sales Apps dal menu.',
    missingBaseUrl: 'URL base Sales Apps non configurato. Impostalo in Vasho Settings.',
  },
  settings: {
    title: 'Impostazioni',
    salesAppVersion: 'URL base Sales Apps',
    salesAppVersionDescription: 'URL base help-center (es. …/sales-apps/v122) o launchpad (es. …/launchpad).',
    save: 'Salva',
    saveSuccess: 'Impostazioni salvate con successo',
    saveError: 'Impossibile salvare le impostazioni. Si prega di riprovare',
    invalidValue: 'Si prega di inserire un valore valido',
  },
};

export default translations;